window.addEventListener = window.addEventListener || window.attachEvent;
window.removeEventListener = window.removeEventListener || window.detachEvent;

/*\
 |*|  :: XMLHttpRequest.prototype.sendAsBinary() Polyfill ::
 |*|  https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#sendAsBinary()
 \*/
if (!XMLHttpRequest.prototype.sendAsBinary) {
    XMLHttpRequest.prototype.sendAsBinary = function (sData) {
        var nBytes = sData.length, ui8Data = new Uint8Array(nBytes);
        for (var nIdx = 0; nIdx < nBytes; nIdx++) {
            ui8Data[nIdx] = sData.charCodeAt(nIdx) & 0xff;
        }
        /* send as ArrayBufferView...: */
        this.send(ui8Data);
        /* ...or as ArrayBuffer (legacy)...: this.send(ui8Data.buffer); */
    };
}

if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

if (!Date.now) {
    Date.now = function () {
        return new Date().getTime();
    };
}

/*
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-/animating
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * MIT license
 */
var rAF, cAF;
var tabState = {};
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
                || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var frameTime = 1000 / 60;
            var timeToCall = Math.max(0, frameTime - Math.abs(currTime - lastTime));
            var id = window.setTimeout(function () {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    rAF = window.requestAnimationFrame;

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    cAF = window.cancelAnimationFrame;
}());

/*END* Polyfill global objects and functions */


function initChangeStates(cSelects) {
    if (cSelects.length !== 0) {
        for (var i = 0; i < cSelects.length; i++) {
            var cs = cSelects[i];
            changeStates(cs.value, cs.form);
        }
    }
}
function changeStates(value, form) {
    try {
        var f = form ? form : document,
                p = f.querySelector(".province-select"),
                s = f.querySelector(".state-select"),
                o = f.querySelector(".other-province-select"),
                r = f.querySelector(".real-province"),
                req = r.className.indexOf("required") === -1 ? "" : " required";

        var reset = function (el) {
            if (req !== "")
                el.className = el.className.replace(req, "");
            el.style.display = "none";
            el.tabIndex = -1;
        };
        var change = function (el) {
            el.removeAttribute("tabindex");
            el.style.display = "block";
            el.className += req;
            el.onchange();
        };

        reset(p);
        reset(s);
        reset(o);
        switch (value.toUpperCase()) {
            case "CA":
            case "CAN":
                change(p);
                break;
            case "US":
            case "USA":
                change(s);
                break;
            default:
                change(o);
                break;
        }
    } catch (ex) {
        try {// Old function
            var f = form ? form : document;
            var p = f.querySelector(".province-select"),
                    s = f.querySelector(".state-select"),
                    o = f.querySelector(".other-province-select"),
                    v = value.toUpperCase();

            p.className = p.className.replace("required", "").trim();
            s.className = s.className.replace("required", "").trim();
            o.className = o.className.replace("required", "").trim();
            if (v === "CA" || v === "CAN") {
                p.style.display = "block";
                s.style.display = "none";
                o.style.display = "none";
                p.className += " required";
                p.onchange();
            } else if (v === "US" || v === "USA") {
                p.style.display = "none";
                s.style.display = "block";
                o.style.display = "none";
                s.className += " required";
                s.onchange();
            } else {
                p.style.display = "none";
                s.style.display = "none";
                o.style.display = "block";
                o.className += " required";
                o.onchange();
            }
        } catch (noSelects) {
        }
    }
}
function setRealProvince(select) {
    select.parentElement.parentElement.querySelector(".real-province").value = select.value;
}
function canadaPC(code) {
    var filter = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
    return filter.test(code);
}
function usaZIP(code) {
    var filter = /^\d{5}([ \-]\d{4})?$/;
    return filter.test(code);
}

function decodeElements(els) {
    var str = "",
            i = 0;

    if (els.length) {
        for (; i < els.length; i++) {
            var el = els[i];
            str = decodeEntities(el.innerHTML);
            el.innerHTML = str;
        }
    } else {
        str = decodeEntities(els.innerHTML);
        els.innerHTML = str;
    }
}
function decodeEntities(str) {
    var ta = document.createElement("textarea");
    ta.innerHTML = str;
    return ta.value;
}

function numLock(e) {
    var k = e.keyCode || e.which;
    // Allow: BACKSPACE, TAB, ENTER, ESCAPE, END, HOME, ARROWS, DELETE, NUMLOCK
    if ([8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 46, 110, 144].indexOf(k) > -1 ||
            // Allow: Ctrl+A, Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+Z, Ctrl+Y
                    ([65, 67, 86, 88, 89, 90].indexOf(k) > -1 && (e.ctrlKey || e.metaKey))) {
        return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (k < 48 || k > 57)) && (k < 96 || k > 105)) {
        e.preventDefault();
    }
}
function setMoney($, round) {
    try {
        var lang = document.documentElement.lang,
                dec = round ? 0 : 2,
                x = isNaN($) ? parseFloat($.replace(",", ".")) : $,
                res = x.toFixed(dec).toString();

        return (lang === "en") ? "$" + res : res.replace(".", ",") + "$";
    } catch (err) {
        return $;
    }
}
function formatMoney($, round) {
    return setMoney($, round);
}

function getTaxes(province, subtotal) {
    var t = {"AB": {"1": 0.05}, "BC": {"1": 0.05}, "MB": {"1": 0.05}, "NB": {"1": 0.15}, "NL": {"1": 0.15}, "NT": {"1": 0.05}, "NS": {"1": 0.15}, "NU": {"1": 0.05}, "ON": {"1": 0.13}, "QC": {"1": 0.05, "2": 0.09975}, "PE": {"1": 0.15}, "SK": {"1": 0.05}, "YT": {"1": 0.05}};

    var t1 = t[province]["1"] * subtotal.replace(",", ".");
    var taxes = [t1];

    if (t[province]["2"] !== undefined) {
        var t2 = parseInt(subtotal + t1) * t[province]["2"];
        taxes.push(t2);
    }
    return taxes;
}

function updateLabel(label, val, lang, callback, noload) {
    var ap = actionPath || "/action/";
    if (!noload) {
        ajaxBlackout(true);
    }
    $.ajax({
        url: ap + "addSiteLabel",
        method: "post",
        type: "post",
        data: {
            lang: lang,
            key: label,
            value: (!val ? "`````" : val)
        },
        cache: false,
        success: function(response) {
            if (!noload) {
                ajaxBlackout(false);
            }
            if (typeof callback === "function") {
                callback(response);
            }
        }
    });
}
function updateLabelLangs(k, v, langs, f, noload) {
    var a = typeof langs === "string" ? langs.split(",") : langs;
    var successCd = a.length;
    var _complete = function () {
        successCd--;
        if (successCd <= 0) {
            ajaxBlackout(false);
            if (f)
                try {
                    f();
                } catch (ex) {
                }
        }
    };
    if (!noload) {
        ajaxBlackout(true);
    }
    for (var i = 0; i < a.length; i++) {
        updateLabel(k, v, a[i], _complete, noload);
    }
}
function updateMultiLabels(o, lang, f, noload) {
    var c = 0, l = 0, timeout = 120, k;
    for (k in o) {
        updateLabel(k, o[k], lang, function () {
            c++;
        }, noload);
        l++;
    }
    var chk = function chk() {
        timeout -= 0.05;
        if (c < l) {
            if (timeout > 0)
                setTimeout(chk, 50);
        } else {
            if (f)
                f();
        }
    }();
}

function getDataSet(el) {
    var map = {};
    if (!el.dataset) {
        var as = el.attributes;
        var tuc = function (x) {
            return x.substr(1).toUpperCase();
        };
        for (var i = 0; i < as.length; i++) {
            var a = as[i];
            var n = a.name;
            var m = n.match(/^data-(.+)/);
            if (m)
                map[m[1].replace(/-([a-z])/ig, tuc)] = a.value;
        }
    } else {
        map = el.dataset;
    }
    return map;
}
function setDataSet(el, key, val) {
    if (!el.dataset) {
        var tlc = function (x) {
            return "-" + x.toLowerCase();
        };
        var att = "data-" + key.replace(/[A-Z]/g, tlc);
        el.setAttribute(att, val);
    } else {
        el.dataset[key] = val;
    }
}

//Tools for the popup for the picker
function pickerAddListener(popup) {
    $('.file-preview-picker-popup-accept-btn', popup).click(filePreviewPickerSumbit);
    $('.file-preview-picker-input', popup).keyup(filePreviewPickerSearch);
    $('.file-preview-picker-item.folder', popup).click(filePreviewPickerDirectoryOpen);

    $('.file-preview-picker-directory-back', popup).click(filePreviewPickerDirectoryClose);

    //A small workaround to detect if the tool has a custom function with callback to close the popup
    //Else, it will do a normal pickerClosePopup()
    $('.picker-popup-close-btn', popup).click(filePreviewPickerClosePopup);
}

function pickerOpenPopup() {
    var t = $(this);
    var isFromGenList = t.data('isFromGenList');
    var popupId = t.attr('data-popup-id');
    var popupToOpen;

    if (isFromGenList) {
        var ctn = t.closest('.gen-list-popup-item-content-ctn');
        popupToOpen = $('.picker-popup[data-popup-id="' + popupId + '"]', ctn).eq(0);
    } else {
        popupToOpen = $('.picker-popup[data-popup-id="' + popupId + '"]').eq(0);
    }

    var mainDirectory = $('.file-preview-picker-main-directory', popupToOpen);
    $('html').addClass('no-scroll');

    popupToOpen.css('display', 'flex').fadeIn(300);
    // Note: setTimeout so it's executed after the first step of fade in rather
    // than have a janky animation after the fade in is completed.
    setTimeout(function () {
        if (!popupToOpen.hasClass('init')) {

            if (mainDirectory.attr('data-use-ajax') === 'true' && popupToOpen.hasClass('file-preview-picker-popup')) {
                filePickerLoadDirectory(mainDirectory.attr('data-directory'), mainDirectory, true);
            }

            $('.file-preview-picker-main-directory > .file-preview-picker-directory', popupToOpen).add(mainDirectory).each(function () {
                var t = $(this);
                t.css('margin-right', t[0].clientWidth - t[0].offsetWidth + "px");
            });

            $('.gen-list-popup-item-textarea', popupToOpen).each(function () {
                $(this).trigger('focus click');
            });

            popupToOpen.addClass('init');
        }
    }, 1);

    //This portion is for the gen-list sort
    if (popupToOpen.hasClass('sort-ascending')) {
        popupToOpen.find('> .picker-popup-window > .picker-popup-content > .popup-default-content-ctn > .gen-list-popup-list').each(function () {
            var list = $(this);
            $('.gen-list-popup-item', list).sort(function (a, b) {
                return $('.gen-list-popup-item-header-title', $(a)).text().toUpperCase().localeCompare($('.gen-list-popup-item-header-title', $(b)).text().toUpperCase());
            }).appendTo(list);
        });
    }
}

function filePickerLoadDirectory(directory, parent, isInitial) {
    var popup = parent.closest('.file-preview-picker-popup');
    var fileItemClone = $('.file-preview-picker-item-big.clone', popup).clone().removeClass('clone');
    var directoryClone = $('.file-preview-picker-directory.clone', popup).clone().removeClass('clone');
    var btn = parent.closest('.file-preview-picker-popup').find('.file-preview-picker-popup-accept-btn');
    var value = typeof (btn.data('value')) === 'object' && btn.data('value')[0] !== undefined ? btn.data('value')[0].fullUrl : btn.data('value');

    if (!parent.hasClass('items-loaded')) {
        if (isInitial) {
            // Don't remove the back button
            parent.children(':not(.file-preview-picker-directory-back-ctn)').remove();
        }

        if (typeof (btn.data('value')) === 'object' && btn.data('value')[0] !== undefined) {
            var finalValue = [];
            value.split(',').forEach(function (item) {
                if (item.trim().length) {
                    var urlSplit = item.split('/');
                    var fullUrl = item.indexOf('/static/uploaded/Files') === 0 ? item : '';
                    var itemName = item.indexOf('/static/uploaded/Files') === 0 ? urlSplit[urlSplit.length - 1] : item;

                    finalValue.push({
                        fullUrl: fullUrl,
                        value: itemName
                    });
                }
            });

            btn.data('value', finalValue);
            value = finalValue;
            parent.addClass('directory-loading');
        }

        $.ajax({
            url: '/action/ajaxMediaManager?directory=' + encodeURIComponent(directory),
            type: 'get',
            success: function (data) {
                var json = JSON.parse(data);
                var extensions = btn.attr('data-extensions').toLowerCase();

                var dirArray = [];
                var itemArray = [];

                json.content.forEach(function (item, index, arr) {
                    if (item.type === 'directory') {
                        dirArray.push(item);
                    } else {
                        itemArray.push(item);
                    }
                });

                dirArray.sort(function (a, b) {
                    return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                });
                itemArray.sort(function (a, b) {
                    return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                });

                json.content = dirArray.concat(itemArray);

                json.content.forEach(function (item, index, arr) {
                    setTimeout(function () {
                        filePickerUpdateParentContent(item, parent, json, extensions, fileItemClone, directoryClone, isInitial, value);
                    }, 1);
                });
                $('.file-preview-picker-directory', parent).each(function () {
                    var t = $(this);
                    t.css('margin-right', t[0].clientWidth - t[0].offsetWidth + "px");
                });
                initFilePickerPopop($('.file-preview-picker-popup-accept-btn', popup));
                parent.addClass('items-loaded');
            },
            complete: function () {
                parent.removeClass('directory-loading');
            }

        });
    }
}

function filePickerUpdateParentContent(item, parent, json, extensions, fileItemClone, directoryClone, isInitial, predefinedValue) {
    var itemClone = fileItemClone.clone();
    var previewItem = $('.file-preview-picker-item', itemClone);
    var value = $('.file-preview-picker-item-value-ctn', itemClone);
    var file = $('.file.clone', itemClone);
    var folder = $('.folder.clone', itemClone);
    var img = $('.image-alt.clone', itemClone);
    var pathSep = isInitial ? '' : '/';
    var path;
    var url = '/static/uploaded/Files';
    var dirFound = false;
    var fileFound = false;
    var popup = parent.closest('.file-preview-picker-popup');
    value.html(item.name);

    json.currentDirectory = json.currentDirectory + (json.currentDirectory[json.currentDirectory.length - 1] === '/' ? '' : '/');

    path = json.currentDirectory + value.text();
    url += path;

    if (item.type === 'directory') {
        var dirClone = directoryClone.clone();
        var innerId = path.replace(/\//g, '-');
        var pathsArray = [];
        var pathsString = '';
        var isSeleted = false;

        if (typeof predefinedValue === 'object') {
            pathsString = [];
            for (var key in predefinedValue) {
                pathsString.push(predefinedValue[key].fullUrl);
            }
        } else {
            pathsString = predefinedValue.split(',');
        }

        //console.log('OG: ' + predefinedValue);
        for (var q = 0; q < pathsString.length; q++) {
            var currPathString = pathsString[q].substring('/static/uploaded/Files'.length).split('/');


            while (currPathString.length > 1) {
                if (currPathString[0] !== '') {
                    currPathString.pop();
                    pathsArray.push('/' + currPathString.join('/'));

                    //pathsArray.push((pathsArray[pathsArray.length-1] || '') + '/' + currPathString.shift());
                } else {
                    currPathString.shift();
                }
            }
        }

        if (typeof (predefinedValue) === 'object' && Object.keys(predefinedValue).length !== 0) {
            dirFound = predefinedValue.reduce(function (bool, current) {
                return bool || current.fullUrl.indexOf(path) != -1;
            }, false);
        }

        dirClone.attr('data-id', innerId)
                .attr('data-directory', path)
                .css('z-index', 10);

        dirClone.find('.file-preview-picker-directory-back')
                .attr('data-id', innerId)
                .click(filePreviewPickerDirectoryClose);

        parent.append(dirClone);

        file.remove();
        img.remove();
        folder.children().unwrap();
        itemClone.children().first()
                .addClass('folder')
                .attr('data-directory-to-open', path)
                .attr('data-directory-parent', json.currentDirectory)
                .attr('data-id', innerId)
                .click(filePreviewPickerDirectoryOpen);

        for (var p = pathsArray.length - 1; p >= 0; p--) {
            if (pathsArray[p] === previewItem.attr('data-directory-to-open')) {
                isSeleted = true;
                break;
            }
        }

        if (isSeleted) {
            itemClone.children().first().addClass('selected');
        }
    } else {
        if (typeof (predefinedValue) === 'object' && Object.keys(predefinedValue).length !== 0) {
            fileFound = predefinedValue.reduce(function (bool, current) {
                return bool || current.fullUrl === url || url.indexOf(current.value) != -1;
            }, false);
        } else if (typeof (predefinedValue) === 'string') {
            var predefinedValueArray = predefinedValue.split(',');
            for (var i = 0; i < predefinedValueArray.length; i++) {
                if (predefinedValueArray[i] === url) {
                    fileFound = true;
                    break;
                }
            }
        }

        if ($('.file-preview-picker-popup-selection-list', popup).length !== 0) {

            if ($('.file-preview-picker-popup-selection-item[data-url="' + url + '"]', popup).length === 0) {
                fileFound = false;
            }
            ;
        }

        if (/(image)|(svg)/.test(item.ext) || item.name.substring(item.name.lastIndexOf('.') + 1) === 'svg') {
            var imgAlt = img.find('img');

            file.remove();
            folder.remove();
            imgAlt.attr('src', url);
            imgAlt.attr('alt', imgAlt.attr('alt') + value.text());
            img.children().unwrap();
        } else {
            img.remove();
            folder.remove();
            file.children().unwrap();
        }
    }

    itemClone.children().first()
            .attr('data-file-url', '/static/uploaded/Files' + json.currentDirectory)
            .attr('data-hashname', item.nameHash)
            .attr('data-value', value.text())
            .attr('data-file-fullurl', '/static/uploaded/Files' + json.currentDirectory + value.text());

    if (item.type === 'directory' || !extensions.trim().length || extensions.indexOf(item.name.split('.')[item.name.split('.').length - 1].toLowerCase()) > -1) {
        parent.append(itemClone);
    }

    if (fileFound) {
        itemClone.children().first().trigger('click');
    }

}

function filePickerUnloadDirectory(directory) {
    directory.find('.file-preview-picker-directory, .file-preview-picker-item-big').remove();
}

function pickerClosePopup(callback) {
    var t = $(this);
    var popup = t.closest('.picker-popup');

    if (popup.attr('data-is-from-gen-list') !== 'true') {
        $('html').removeClass('no-scroll');
    }

    popup.fadeOut(300, function () {
        if (typeof (callback) === 'function') {
            callback();
        }
    });
}

function pickerChangeTab() {
    var t = $(this);
    var id = t.attr('data-file-picker-tab');
    var popup = t.closest('.picker-popup');

    if (!t.hasClass('selected')) {
        $('.file-preview-picker-tab-btn, .file-preview-picker-tab-ctn', popup).removeClass('selected');
        $('.file-preview-picker-tab-btn[data-file-picker-tab="' + id + '"], .file-preview-picker-tab-ctn[data-file-picker-tab="' + id + '"]', popup).addClass('selected');
    }
}

function pickerSelectionItemDel() {
    var t = $(this);
    var item = t.closest('.file-preview-picker-popup-selection-item');
    var url = item.attr('data-url');
    var popup = item.closest('.file-preview-picker-popup');

    if ($('.file-preview-picker-item[data-file-fullurl="' + url + '"]').length !== 0) {
        $('.file-preview-picker-item[data-file-fullurl="' + url + '"]').trigger('click');
    } else {
        item.remove();
        filePreviewCheckDetailTabCounter(popup);
        pickerCheckIfUnloadedFilterHasUnselectedItem(popup)
    }
}

function pickerCheckIfUnloadedFilterHasUnselectedItem(popup) {
    $('.file-preview-picker-item.selected.folder', popup).filter(function () {
        return !$('.file-preview-picker-directory[data-id="' + $(this).attr('data-id') + '"]', popup).hasClass('items-loaded');
    }).each(function () {
        var t = $(this);
        var directory = t.attr('data-file-fullurl');
        var hasChild = false;

        $('.file-preview-picker-popup-selection-item:not(.clone)', popup).each(function () {
            var url = $(this).attr('data-url').substring(0, $(this).attr('data-url').lastIndexOf('/'));

            if (url === directory) {
                hasChild = true;
            }
        });

        if (hasChild) {
            t.addClass('selected');
        } else {
            t.removeClass('selected');
        }
    });
}

function initPickerSelectionItemsSortable() {
    if ($('.file-preview-picker-popup-selection-list').length !== 0) {
        $('.file-preview-picker-popup-selection-list').sortable({
            handle: ".file-preview-picker-popup-selection-handle",
            helper: fixHelper
        });
    }
}

//Tools for gen list popup
function genListToggleItem() {
    var t = $(this);
    var ctn = t.closest('.gen-list-popup-item');

    if (ctn.hasClass('open')) {
        $('> .gen-list-popup-item-content-ctn', ctn).slideUp(200, function () {
            ctn.removeClass('open');
        });
    } else {
        $('> .gen-list-popup-item-content-ctn', ctn).slideDown(200, function () {
            ctn.addClass('open');
        });
    }
}

function genListAddItem() {
    var t = $(this);
    var popup = t.closest('.picker-popup');
    var currLabelId = popup.attr('data-label-id');
    var content = $('> .picker-popup-window > .picker-popup-content > .popup-default-content-ctn', popup);
    var list = $('> .gen-list-popup-list', content);
    var clone = $('.gen-list-popup-item', list).eq(0).clone();
    var newId = createUniqueCharId();
    var order = $('> .gen-list-popup-item:not(.clone.disabled)', list).length;
    var limit = t.attr('data-limit');

    if (order >= limit) {
        return;
    } else if (order + 1 >= limit) {
        t.addClass('disabled');
    }

    clone.removeClass('open clone disabled');
    $('.gen-list-popup-item-content-ctn', clone).slideUp(0);
    clone.attr('data-id-temp', newId);
    clone.removeAttr('style data-id data-item-id');
    clone.attr('data-order', order);
    $('.gen-list-popup-item-header-title', clone).html('Item <span class="gen-list-popup-item-header-title-pos">' + (order + 1) + '</span>').removeAttr('data-has-field-value');
    $('.gen-list-popup-item-text', clone).each(function () {
        if ($(this).attr('data-default-value') !== '') {
            $(this).val($(this).attr('data-default-value'));
        } else {
            $(this).val('');
        }
    });
    $('.gen-list-popup-item-bigtext', clone).each(function () {
        if ($(this).attr('data-default-value') !== '') {
            $(this).val($(this).attr('data-default-value'));
        } else {
            $(this).val('');
        }
    });
    $('.gen-list-popup-item-select', clone).val($('.gen-list-popup-item-select option', clone).eq(0).val());
    $('.gen-list-popup-file-picker-value', clone).html('');
    $('.alert-submit-form-gen-list', clone).attr('data-gen-listception-item-id', '');
    $('.mce-tinymce', clone).remove();
    $('.gen-list-popup-item-textarea', clone).removeAttr('id').removeAttr('style').removeAttr('aria-hidden').html('');
    $('.picele', clone).html('');


    $('.gen-list-popup-item-content-item', clone).attr('data-order', order);
    $('.alert-submit-form-gen-list.hidden', clone).removeClass('hidden');
    var btnGenList = $('.gen-list-popup-gen-list-btn', clone);
    btnGenList.hide();

    var stoolIconpickMod = $('.stool-icopick-mod', clone);
    var iconRegExp = new RegExp(('gen-list-popup-' + currLabelId + '-(.*?)-\\d+$').replace(/\-/g, '\\-'), 'g');
    var key = iconRegExp.exec(stoolIconpickMod.attr('data-key'));
    if (key != null) {
        var newIconPickerKey = 'gen-list-popup-' + currLabelId + '-' + key[1] + '-' + (order + 1);
        $('.stool-icopick-mod', clone).attr('data-window-id', newIconPickerKey);
        $('[id^="gen-list-popup-' + currLabelId + '-' + key[1] + '-"]', clone).attr('id', newIconPickerKey);
        $('[onclick^="closeWindow"]', clone).attr('onclick', "closeWindow('" + newIconPickerKey + "')");
    }

    $('.gen-list-popup-item-content-item[data-type="file"]', clone).each(function (i) {
        var t = $(this);
        var newLabelId = 'gen-list-popup-' + newId + '-' + i;
        var assocPopup = $('.gen-list-file-popup', clone).eq(i);
        var currItemId = t.attr('data-id');
        $('.picker-popup-button', t).attr('data-label-id', newLabelId);
        $('.picker-popup-button', t).click(pickerOpenPopup);

        assocPopup.attr('data-label-id', newLabelId);
        $('.gen-list-popup-file-picker-value', t).attr('data-id', currItemId);
        $('.file-preview-picker-popup-accept-btn', assocPopup).attr('data-element-to-update', '.gen-list-popup-item[data-id-temp="' + newId + '"] .gen-list-popup-file-picker-value[data-id="' + currItemId + '"]');
        $('.file-preview-picker-item', assocPopup).removeClass('selected');
        pickerAddListener(assocPopup);
    });

    $('.gen-list-popup-item-select-selected-item:not(.clone)', clone).remove();
    $('.gen-list-popup-item-select option', clone).show();

    $('.gen-list-popup-item-select', clone).each(function () {
        if ($(this).closest('.gen-list-popup-item-select-ctn').attr('data-multi') === 'true') {
            $(this).on('change', genListPopupItemSelectChange);
        }
    });

    $('.gen-list-popup-item-friendly-url-input', clone).val('');
    $('.gen-list-popup-item-header-friendly', clone).html('');

    /* var popupClone = $('.gen-list-file-popup[data-label-id="'+currLabelId+'"]').eq(0).clone().removeClass('clone');
     popupClone.attr('data-label-id', newLabelId);
     $('.file-preview-picker-popup-accept-btn', popupClone).attr('data-element-to-update', '.gen-list-popup-item[data-id-temp="'+newId+'"] .gen-list-popup-file-picker-value');
     $('.file-preview-picker-item', popupClone).removeClass('selected');
     
     pickerAddListener(popupClone);*/

    $('.color-picker-color-picker-ctn', clone).attr('data-current-color', '#ff0000');

    $('.edit-link-tab', clone).each(function () {
        $(this).removeAttr('checked');
        $(this).attr('name', 'type-' + newId + '-' + ($(this).closest('.gen-list-popup-item-content-item').attr('data-id')));
    });
    $('.radioLabelContainer:first-child .edit-link-tab', clone).trigger('click');
    $('select[name="page"], select[name="internal"], select[name="external"], select[name="target"]', clone).val('');
    $('select[name="page"] option, select[name="internal"] option, select[name="external"] option, select[name="target"] option', clone).removeAttr('selected');
    $('input[name="query"], input[name="event"], input[name="text"]', clone).val('');

    list.append(clone);

    $('.gen-com-select .gen-list-popup-item-select', clone).trigger('change');

    CPclearCanvasListeners();
    CPsetupHueCanvas();
    CPsetupCanvasListeners();
    CPsetColor();

    genlistTinyMCE('.gen-list-mce:not([id^="mce_"])');
    // content.append(popupClone);
}

function genlistTinyMCE(selector) {
    if ($('body').hasClass('is-logged-in') || $(selector).length) {
        var defaultPluginSettings = "paste link textcolor lists";
        var overwritePluginSettings = $(selector).closest('.gen-list-popup-list').attr('data-tinymce-plugin-setting');
        var pluginSettings = overwritePluginSettings !== undefined ? overwritePluginSettings : defaultPluginSettings;

        var defaultToolbarSettings = "formatselect | bold italic strikethrough forecolor | alignleft aligncenter alignright alignjustify  | numlist bullist | link | removeformat";
        var overwriteToobarSettings = $(selector).closest('.gen-list-popup-list').attr('data-tinymce-toolbar-setting');
        var toolbarSettings = overwriteToobarSettings !== undefined ? overwriteToobarSettings : defaultToolbarSettings;

        $(selector).each(function (i) {
            var t = $(this).addClass('gen-list-mce-' + i);
            t.prev().addClass('gen-list-mce-toolbar-' + i);

            /*
             * NOTE (william): if the first node isn't of type 10 (DOCUMENT_TYPE_NODE), the 
             * first line is most likely the xml version declaration which means we're using 
             * the old XMLWriter instead of the updated HTMLWriter and we should delete the 
             * duplicated <br/>s.
             */
            if (document.firstChild.nodeType != 10) {
                var brs = $('br', t);

                for (var iBr = brs.length - 1; iBr >= 0; iBr--) {
                    if (iBr % 2 == 1) {
                        brs.eq(iBr).remove();
                    }
                }
            }

            var settings = {
                selector: '.gen-list-mce-' + i,
                menubar: false,
                inline: true,
                plugins: pluginSettings,
                toolbar: toolbarSettings,
                urlconverter_callback: 'customURLConverter',
                relative_urls: true,
                remove_script_host: true,
                entity_encoding: "raw",
                paste_as_text: true,
                fixed_toolbar_container: '.gen-list-mce-toolbar-' + i,
                theme_advanced_blockformats: "p,h1,h2,h3,h4,h5,h6,blockquote"
            };

            /*if ($(selector).closest('.gen-list-popup-list').attr('data-tinymce-textcolor-map') !== undefined) {
             settings["textcolor_map"] = $(selector).closest('.gen-list-popup-list').attr('data-tinymce-textcolor-map');
             }*/

            genlistTinyMCEInit(settings);
        });
    }
}

function genlistTinyMCEInit(settings) {
    if (typeof tinymce === 'object') {
        tinymce.init(settings);
    } else {
        setTimeout(function () {
            genlistTinyMCEInit(settings);
        }, 1000);
    }
}

function genListDelete() {
    var t = $(this);
    var item = t.closest('.gen-list-popup-item');
    var id = item.attr('data-id');
    var ctn = t.closest('.picker-popup-content');
    var btn = $('.gen-list-popup-add-item-btn', ctn);

    if (btn.hasClass('disabled')) {
        btn.removeClass('disabled');
    }

    item.slideUp(300, function () {
        if (!item.siblings().length) {
            item.addClass('clone disabled');
        } else {
            item.remove();
        }
    });

    if (id !== undefined) {
        $.ajax({
            url: '/action/manageGenData',
            data: {
                id: id,
                delete: 'true',
                ajax: 'true'
            },
            cache: false
        });
    }
}

function initFilePickerPopop(items) {
    items.each(function () {
        var t = $(this);
        if (typeof t.data('value') === "string") {
            if (t.data('value').length !== 0) {
                var imgs = t.data('value').split(',');
                var obj = {};
                for (var i = 0; i < imgs.length; i++) {
                    obj[i] = {
                        fullUrl: imgs[i],
                        value: imgs[i].substring(imgs[i].lastIndexOf('/') + 1),
                        hash: ''
                    };
                }

                t.attr('data-value', JSON.stringify(obj));
            } else {
                t.attr('data-value', '{}');
            }
        }
    });
}

function initGenListPopupItemsLimit() {
    if ($('.gen-list-popup-item .gen-list-popup-item-header-handle').length !== 0) {
        $('.gen-list-popup-list').each(function () {
            var ctn = this.parentNode;
            var btn = $('.gen-list-popup-add-item-btn', ctn);
            var order = $('.gen-list-popup-item:not(.clone.disabled)', this).length;
            var limit = btn.attr('data-limit');
            if (order >= limit) {
                btn.addClass('disabled');
            }
        });
    }

    $('.gen-list-popup-item-bigtext').each(function () {
        $(this).val($(this).val().replace(new RegExp('<br/>', 'g'), '\n'));
    });
}

function initGenListPopupItemsSortable() {
    if ($('.gen-list-popup-item .gen-list-popup-item-header-handle').length !== 0) {
        $('.gen-list-popup-list').sortable({
            handle: ".gen-list-popup-item-header-handle",
            helper: fixHelper,
            stop: function (event, ui) {
                var item = ui.item;
                var list = ui.item.closest('.gen-list-popup-list');

                genListUpdateItemsOrder(list);
            }
        });
    }
}

function genListUpdateItemsOrder(list, autosave) {
    var items = $('.gen-list-popup-item:not(.clone.disabled)', list);

    items.each(function (i) {
        var id = $(this).attr('data-id');
        var newPosition = (i + 1);

        if ($('.gen-list-popup-item-header-title', $(this)).attr('data-has-field-value') !== 'true') {
            $('.gen-list-popup-item-header-title .gen-list-popup-item-header-title-pos', $(this)).html(newPosition);
        }

        $.ajax({
            url: '/action/manageGenData',
            data: {
                id: id,
                field5: newPosition,
                ajax: 'true'
            },
            cache: false
        });
    });
}

function genListPopupAdminUpdateExtra() {
    var t = $(this);
    var item = t.closest('.gen-list-popup-admin-item');

    $('.gen-list-popup-admin-item-extra', item).removeClass('show');

    if (t.val() === 'text') {
        $('.gen-list-popup-admin-item-extra.text', item).addClass('show');
    } else if (t.val() === 'bigtext') {
        $('.gen-list-popup-admin-item-extra.bigtext', item).addClass('show');
    } else if (t.val() === 'select') {
        $('.gen-list-popup-admin-item-extra.select', item).addClass('show');
    } else if (t.val() === 'file') {
        $('.gen-list-popup-admin-item-extra.file', item).addClass('show');
    } else if (t.val() === 'gen-list') {
        $('.gen-list-popup-admin-item-extra.gen-list', item).addClass('show');
    } else if (t.val() === 'icon') {
        $('.gen-list-popup-admin-item-extra.icon', item).addClass('show');
    } else if (t.val() === 'checkbox') {
        $('.gen-list-popup-admin-item-extra.checkbox', item).addClass('show');
    } else if (t.val() === 'link') {
        $('.gen-list-popup-admin-item-extra.link', item).addClass('show');
    }
}

function genListPopupAdminAddItem() {
    var t = $(this);
    var ctn = t.closest('.gen-list-popup-admin');
    var list = $('.gen-list-popup-admin-list', ctn);
    var items = $('.gen-list-popup-admin-item', list);
    var clone = $('.gen-list-popup-admin-item.clone', ctn).clone().removeClass('clone');

    var currType = $('.gen-list-popup-admin-item-type', clone).val();
    $('.gen-list-popup-admin-item-extra.' + currType, clone).addClass('show');

    $('.gen-list-popup-admin-item-header-title-num', clone).html(items.length + 1);

    list.append(clone);
}

function createUniqueCharId(length) {
    if (length === undefined) {
        length = 5;
    }

    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var string = '';

    for (var i = 0; i < length; i++) {
        string += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return string;
}

function genListCheckboxInputClick() {
    var t = $(this);
    var ctn = t.closest('.gen-list-popup-item-select-ctn');
    var max = parseInt(ctn.attr('data-max'));
    var itemCount = $('.gen-list-item-checkbox-input:checked', ctn).length;

    if (itemCount > max) {
        t.prop('checked', false);
    }
}

function genListItemGenComChange() {
    var t = $(this);
    var val = $('option:selected', t).val();
    var item = t.closest('.gen-list-popup-item-content-ctn');

    $('.gen-list-popup-item-content-item', item).removeClass('show-gencom');
    $('.gen-list-popup-item-content-item[data-gencom="' + val + '"]', item).addClass('show-gencom');
}

function genListSubmit(callbackAfterSave) {
    var t = $(this);
    var popup = t.closest('.gen-list-popup');
    var popupProcessingCtn = t.closest('.picker-popup-window');
    var labelId = popup.attr('data-label-id');
    var items = $('.gen-list-popup-list:first > .gen-list-popup-item:not(.clone.disabled)', popup);
    var nbItems = items.length;
    var nbItemsDone = 0;
    var currLang = popup.attr('data-curr-lang');
    var allLangs = popup.attr('data-all-langs') || popup.attr('data-all-lang');
    var saveInAllLangs = t.data('saveInAllLangs');
    var langToSave = currLang;
    var genListWithoutItemIds = [];
    var genListWithoutItemIdsAdmin = [];
    if (saveInAllLangs) {
        langToSave = allLangs;
    }

    popupProcessingCtn.addClass('is-processing');

    items.each(function (i) {
        var item = $(this);
        var gendataId = item.attr('data-id');
        var json = {};
        var ids = '';
        var allowEditFriendlyURL = item.attr('data-edit-friendly-url');
        genListWithoutItemIds = [];
        genListWithoutItemIdsAdmin = [];
        var genComValue = $('.gen-list-popup-item-content-ctn:first > .gen-list-popup-item-content-item.gen-com-select option:selected', item).val();
        var isOk = true;

        t.prop('disabled', true);
        items.removeClass('has-error');

        $('.gen-list-popup-item-content-ctn:first > .gen-list-popup-item-content-item', item).each(function (k) {
            var l = $(this);
            var id = l.attr('data-id');
            var type = l.attr('data-type');
            var required = l.hasClass('required');

            //Required validation
            if (required) {
                if (type === 'text') {
                    validateField($('.gen-list-popup-item-text', l));
                } else if (type === 'bigtext') {
                    validateField($('.gen-list-popup-item-bigtext', l));
                } else if (type === 'textarea') {
                    if (tinymce.get($('.gen-list-popup-item-textarea', l).attr('id')).getContent().length === 0) {
                        l.addClass('error');
                    } else {
                        l.removeClass('error');
                    }
                } else if (type === 'select-country') {
                    if ($('.gen-list-popup-item-select-country', l).val().length === 0 || $('.gen-list-popup-item-select-state.selected', l).val().length === 0) {
                        l.addClass('error');
                    } else {
                        l.removeClass('error');
                    }
                } else if (type === 'select' || (type === 'custom' && l.hasClass('gen-com-select'))) {
                    if ($('.gen-list-popup-item-select', l).val().length !== 0 || $('.gen-list-popup-item-select-selected-item:not(.clone)', l).length !== 0) {
                        l.removeClass('error');
                    } else {
                        l.addClass('error');
                    }
                } else if (type === 'file') {
                    if ($('.gen-list-popup-file-picker-value', l).text().length === 0) {
                        l.addClass('error');
                    } else {
                        l.removeClass('error');
                    }
                } else if (type === 'gen-list') {
                } else if (type === 'icon') {
                    if ($('.picele', l).text().length === 0) {
                        l.addClass('error');
                    } else {
                        l.removeClass('error');
                    }
                } else if (type === 'color') {
                    if ($('.color-picker-color-picker-ctn', l).length === 0) {
                        l.addClass('error');
                    } else {
                        l.removeClass('error');
                    }
                } else if (type === 'checkbox') {
                    if ($('.gen-list-item-checkbox-input:checked', l).length === 0) {
                        l.addClass('error');
                    } else {
                        l.removeClass('error');
                    }
                } else if (type === 'link') {
                    // if ($('.gen-list-item-checkbox-input:checked', l).length === 0) {
                    //     l.addClass('error');
                    // } else {
                    //     l.removeClass('error');
                    // }
                }
            }


            if (l.hasClass('error') && !(l.css('display') === 'none')) {
                $('.gen-list-popup-item-error-message', l).slideDown('200');
                isOk = false;
            } else {
                $('.gen-list-popup-item-error-message', l).slideUp('200');
            }
        });

        if (isOk) {
            $('.gen-list-popup-item-content-ctn:first > .gen-list-popup-item-content-item:not(.gen-com-select)', item).each(function (k) {
                var l = $(this);
                var id = l.attr('data-id');
                var type = l.attr('data-type');

                json[id] = '';

                if (type === 'text') {
                    json[id] = $('.gen-list-popup-item-text', l).val();
                }
                if (type === 'bigtext') {
                    json[id] = $('.gen-list-popup-item-bigtext', l).val().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2');
                } else if (type === 'textarea') {
                    json[id] = "<div class='gen-list-popup-item-textarea' data-id='" + id + "'>" + tinymce.get($('.gen-list-popup-item-textarea', l).attr('id')).getContent() + "</div>";
                } else if (type === 'select-country') {
                    json[id] = $('.gen-list-popup-item-select-country', l).val();
                    json[id] += '::';
                    json[id] += $('.gen-list-popup-item-select-state.selected', l).val();
                } else if (type === 'select') {
                    var isMulti = $('.gen-list-popup-item-select-ctn', l).attr('data-multi') !== undefined ? $('.gen-list-popup-item-select-ctn', l).attr('data-multi') : 'false';

                    if (isMulti === 'true') {
                        $('.gen-list-popup-item-select-selected-item:not(.clone)', l).each(function (q) {
                            if (q !== 0) {
                                json[id] += ',';
                            }

                            json[id] += $('.gen-list-popup-item-select-selected-item-val', $(this)).html();
                            json[id] += '::';
                            json[id] += $('.gen-list-popup-item-select-selected-item-inner', $(this)).html();
                        });
                    } else {
                        json[id] = $('.gen-list-popup-item-select', l).val();
                    }
                } else if (type === 'file') {
                    if ($('.gen-list-popup-file-picker-value', l).html().charAt(0) === ',') {
                        json[id] = $('.gen-list-popup-file-picker-value', l).html().substring(1);
                    } else {
                        json[id] = $('.gen-list-popup-file-picker-value', l).html();
                    }
                } else if (type === 'gen-list') {
                    json[id] = $('.gen-list-popup-gen-list-btn', l).attr('data-label-id') ? $('.gen-list-popup-gen-list-btn', l).attr('data-label-id') : "";
                    var genListceptionCurrId = $('.alert-submit-form-gen-list', l).attr('data-gen-listception-item-id');
                    if (genListceptionCurrId === '') {
                        genListWithoutItemIds.push(id);
                        if ($('.gen-list-popup-gen-list-btn', l).attr('data-label-id') !== undefined && $('.gen-list-popup-gen-list-btn', l).attr('data-label-id').indexOf(l.attr('data-gen-listception-admin-id')) === -1) {
                            genListWithoutItemIdsAdmin.push("");
                        } else {
                            genListWithoutItemIdsAdmin.push(l.attr('data-gen-listception-admin-id'));
                        }

                    }
                } else if (type === 'icon') {
                    json[id] = $('.picele', l).html();
                } else if (type === 'color') {
                    json[id] = $('.color-picker-color-picker-ctn', l).attr('data-current-color');
                } else if (type === 'checkbox') {
                    $('input[name="gen-list-item-checkbox-' + id + '"]:checked', l).each(function (chk) {
                        if (chk !== 0) {
                            json[id] += ',';
                        }

                        json[id] += $(this).val();
                    });
                } else if (type === 'link') {
                    var linkType = $('.edit-link-tab:checked', l).val();
                    var linkHref = '';

                    if (linkType === 'page') {
                        linkHref = $('select[name="page"]', l).val();
                    } else if (linkType === 'internal') {
                        linkHref = $('[name="internal"]', l).val();
                    } else if (linkType === 'external') {
                        linkHref = $('input[name="external"]', l).val();
                    }

                    json[id] = {
                        type: linkType,
                        href: linkHref,
                        query: $('input[name="query"]', l).val(),
                        event: $('input[name="event"]', l).val(),
                        targ: $('select[name="target"]', l).val(),
                        text: $('input[name="text"]', l).val()
                    };
                }

                if (k !== 0) {
                    ids += ',';
                }

                ids += l.attr('data-id');
            });


            var data = {
                field1: 'gen-list', //ID
                field2: labelId,
                field4: JSON.stringify(json) //Json with all the inner fields value
                    .replace(/\\n/g, "")
                    .replace(/\\r/g, "")
                    .replace(/\\t/g, "")
                    .replace(/\\b/g, "")
                    .replace(/\\f/g, ""),
                field5: i, //Order
                field6: ids,
                field7: genComValue,
                field10: langToSave,
                //Ne pa prendre Extradata pour le laisser aux sites spécifique
                ajax: 'true'
            };

            if (gendataId !== undefined) {
                data.id = gendataId;
            }

            if (allowEditFriendlyURL === 'true') {
                var currUrl = urlSafeText($('.gen-list-popup-item-friendly-url-input', item).last().val());
                if (currUrl.indexOf("-" + gendataId) != '-1') {
                    currUrl = currUrl.substr(0, currUrl.indexOf("-" + gendataId));
                }
                data.friendlyUrl = currUrl;
            }

            $.ajax({
                url: '/action/manageGenData',
                data: data,
                method: 'POST',
                cache: false,
                success: function (data) {
                    nbItemsDone++;
                    gendataId = data.split('-')[1];
                    item.attr('data-id', gendataId);
                    item.attr('data-item-id', gendataId);
                    updateGenListJson(gendataId, json, genListWithoutItemIds, genListWithoutItemIdsAdmin, function () {
                        if (nbItemsDone === nbItems) {
                            if (genListWithoutItemIds.length) {
                                window.location.reload();
                            } else if (callbackAfterSave !== undefined && typeof callbackAfterSave === 'function') {
                                callbackAfterSave();
                                popupProcessingCtn.removeClass('is-processing');
                                t.prop('disabled', false);
                            } else if (popup.attr('data-is-from-gen-list') === 'true') {
                                filePreviewPickerClosePopup.apply($('.picker-popup-close-btn', popup));
                                popupProcessingCtn.removeClass('is-processing');
                                t.prop('disabled', false);
                            } else {
                                window.location.reload();
                            }
                        }
                    });
                }
            });
        } else {
            item.addClass('has-error');
            t.prop('disabled', false);
            popupProcessingCtn.removeClass('is-processing');
        }
    });
}

var updateGenListJson = function (id, json, indexes, adminIdArray, callback) {
    if (indexes.length > 0) {
        for (var i in indexes) {
            var sb = (adminIdArray[i] === "") ? "" : '-' + adminIdArray[i]; //retro-compatibility with previously created genlist
            json[indexes[i]] = "sub-gen-list-" + id + sb;
        }
        var params = {
            id: id,
            field4: JSON.stringify(json)
                .replace(/\\n/g, "")
                .replace(/\\r/g, "")
                .replace(/\\t/g, "")
                .replace(/\\b/g, "")
                .replace(/\\f/g, ""),
            ajax: 'true'
        };
        $.ajax({
            url: '/action/manageGenData',
            data: params,
            method: 'POST',
            cache: false,
            success: function (data) {
                callback();
            }
        });
    } else {
        callback();
    }
};

var validateForm = function (ctn) {
    ctn.each(function () {
        var t = $(this);
        var toValidateItems = $('.form-input:not(.select-state-input:not(.selected))', t);
        var toValidateUpload = $('.form-item-upload.required', t);
        var toValidateCheck = $('.form-check-input.required', t);
        var password = $('.js-password', t);
        var passwordConfirm = $('.js-password-confirm', t);
        var email = $('.js-email', t);
        var emailConfirm = $('.js-email-confirm', t);
        var btn = $('.js-form-btn', t);
        var isOk = true;
        var passwordOk = true;
        var termsOk = true;
        var checkOk = true;
        var emailOk = true;
        var fieldsErrorMessage = $('.js-form-error-message.fields', t);
        var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
        var fieldsErrorTerms = $('.js-form-error-message.terms', t);
        var fieldsErrorPassword = $('.js-form-error-message.password', t);
        var fieldsErrorEmail = $('.js-form-error-message.email-check', t);

        toValidateItems.each(function () {
            var tChild = $(this);
            validateField(tChild);
            if (tChild.hasClass('error')) {
                isOk = false;
            }
        });

        toValidateUpload.each(function () {
            var tUpload = $(this);
            var input = $('.form-item-upload-input', tUpload);

            if (input.val() === '') {
                tUpload.addClass('error');
            }

            if (tUpload.hasClass('error')) {
                isOk = false;
            }
        });

        toValidateCheck.each(function () {
            var tCheck = $(this);
            var name = tCheck.attr('name');
            var tCtn = tCheck.closest('.form-checkbox-ctn');
            var form = tCheck.closest('form');

            if (!tCheck.is(':checked') && !$('.form-check-input[name=' + name + ']', form).is(':checked')) {
                tCtn.addClass('error');

                if (tCtn.attr('name') !== 'terms') {
                    checkOk = false;
                }
            } else {
                tCtn.removeClass('error');
            }

            if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
                termsOk = false;
            }

            if (tCtn.hasClass('error')) {
                termsOk = false;
            }
        });

        if (password.length !== 0 && passwordConfirm.length !== 0 && (password.val() !== passwordConfirm.val() || password.val().length === 0)) {
            if (password.val().length === 0) {
                password.removeClass('success').addClass('error');
                passwordOk = false;
            } else {
                password.addClass('success').removeClass('error');
                passwordOk = true;
            }

            if (password.val() !== passwordConfirm.val() || passwordConfirm.val().length === 0) {
                passwordConfirm.removeClass('success').addClass('error');
                passwordOk = false;
            } else {
                passwordConfirm.removeClass('error');
                passwordOk = true;

                if (password.val().length !== 0) {
                    passwordConfirm.addClass('success');
                }
            }
        }

        if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
            if (email.val().length === 0) {
                email.removeClass('success').addClass('error');
                emailOk = false;
            } else {
                email.addClass('success').removeClass('error');
                emailOk = true;
            }

            if (email.val() !== emailConfirm.val() || (email.val().length === 0)) {
                emailConfirm.removeClass('success').addClass('error');
                emailOk = false;
            } else {
                emailConfirm.removeClass('error');
                emailOk = true;

                if (email.val().length !== 0) {
                    emailConfirm.addClass('success');
                }
            }
        }

        t.addClass('is-checked');

        if (!termsOk) {
            fieldsErrorTerms.slideDown(300);
        } else {
            fieldsErrorTerms.slideUp(300);
        }

        if (!checkOk) {
            fieldsErrorCheckbox.slideDown(300);
        } else {
            fieldsErrorCheckbox.slideUp(300);
        }

        if (password.length !== 0 && passwordConfirm.length !== 0) {
            if (password.length !== 0 && passwordOk) {
                ctn.addClass('has-password');
                password.add(passwordConfirm).removeClass('error');
                fieldsErrorPassword.slideUp(300);
            } else {
                ctn.removeClass('has-password');
                password.add(passwordConfirm).addClass('error');
                fieldsErrorPassword.slideDown(300);
            }
        }

        if (email.length !== 0 && emailConfirm.length !== 0) {
            if (email.length !== 0 && emailOk) {
                ctn.addClass('has-email');
                email.add(emailConfirm).removeClass('error');
                fieldsErrorEmail.slideUp(300);
            } else {
                ctn.removeClass('has-email');
                email.add(emailConfirm).addClass('error');
                fieldsErrorEmail.slideDown(300);
            }
        }

        if (!isOk) {
            fieldsErrorMessage.slideDown(300);
        } else {
            fieldsErrorMessage.slideUp(300);
        }

        if (!isOk || !passwordOk || !termsOk || !checkOk || !emailOk) {
            btn.addClass('disabled');
            ctn.addClass('has-error');

            if (!passwordOk && password.hasClass('required')) {
                ctn.addClass('error-password');
            } else {
                ctn.removeClass('error-password');
            }
            return false;
        } else {
            btn.removeClass('disabled');
            ctn.removeClass('has-error').removeClass('error-password');

            fieldsErrorTerms.slideUp(300);
            return true;
        }
    });
};

var validateField = function (elt) {
    var tag = elt[0].tagName;
    var type = elt.attr('type');
    var val = elt.val() || '';
    var attrClass = elt.attr('data-validator-apply-class-on');
    var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
    //Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
    //the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
    var validate = elt.attr('data-validate');
    var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
    var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    var emailValid = true;
    var whiteSpaceValid = true;
    var urlValid = true;
    var telValid = true;
    var inputValid = true;

    if (!val.replace(/\s/g, '').length) {
        whiteSpaceValid = false;
    }

    if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
        emailValid = reEmail.test(val);
    } else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
        urlValid = reUrl.test(val);
    } else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
        telValid = reTel.test(val);
    } else if (elt.hasClass('form-item-upload-input')) {
        if (classTarget.add(elt).hasClass('required') && elt.val() !== '') {
            classTarget.add(elt).removeClass('error').addClass('success');
        } else {
            classTarget.add(elt).addClass('error').removeClass('success');
        }
    } else {
        classTarget.add(elt).addClass('success').removeClass('error');
        if (classTarget.hasClass('required') && $.trim(val).length === 0) {
            classTarget.add(elt).removeClass('success').addClass('error');
            inputValid = false;
        } else if (!classTarget.hasClass('required') && val.length === 0) {
            classTarget.add(elt).removeClass('success').removeClass('error');
        }
    }

    if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
        classTarget.add(elt).removeClass('error').addClass('success');
    } else if (val.length === 0 && !classTarget.hasClass('required')) {
        classTarget.add(elt).removeClass('error').removeClass('success');
    } else {
        classTarget.add(elt).addClass('error').removeClass('success');
    }
};

function urlSafeText(text) {
    var translate = {
        '\u00E0': 'a', // à
        '\u00E2': 'a', // â
        '\u00E7': 'c', // ç
        '\u00E9': 'e', // é
        '\u00E8': 'e', // è
        '\u00EA': 'e', // ê
        '\u00EB': 'e', // ë
        '\u00F4': 'o', // ô
        '\u00EE': 'i', // î
        '\u00EF': 'i', // ï
        '\u00E6': 'ae', // æ
        '\u0153': 'oe'  // œ
    };
    var translateRegEx = /[\u00E0\u00E2\u00E7\u00E9\u00E8\u00EA\u00EB\u00F4\u00EE\u00EF\u00E6\u0153]/g;
    var finalString = text.toLowerCase()
            .replace(/(&amp;)|\s+/g, '-')
            .replace(translateRegEx, function (match) {
                return translate[match];
            })
            .replace(/[^a-z0-9\-_]/g, '');

    return finalString;
}

function genListPopupAdminAddSaveList() {
    var t = $(this);
    var ctn = t.closest('.gen-list-popup-admin');
    var popup = ctn.closest('.gen-list-popup');

    genListSaveAdminPopup(popup);
}

function genListPopupAdminDelItem() {
    var t = $(this);
    var item = t.closest('.gen-list-popup-admin-item');
    var popup = item.closest('.gen-list-popup');

    item.remove();
    genListUpdateAdminItemsOrder(popup);
}

function initGenListPopupAdminSortable() {
    if ($('.gen-list-popup-admin-item-handle').length !== 0) {
        $('.gen-list-popup-admin-list').sortable({
            handle: ".gen-list-popup-admin-item-handle",
            items: ".gen-list-popup-admin-item",
            helper: fixHelper,
            stop: function (event, ui) {
                var item = ui.item;
                var popup = ui.item.closest('.gen-list-popup');

                genListUpdateAdminItemsOrder(popup);
            }
        });
    }
}

function genListSaveAdminPopup(popup) {
    var adminId = popup.attr('data-admin-id');
    var popupId = adminId === undefined ? popup.attr('data-label-id') : adminId;
    var items = $('.gen-list-popup-admin[data-admin="' + popupId + '"] .gen-list-popup-admin-item:not(.clone)', popup);
    var genId = popup.attr('data-id') !== undefined ? popup.attr('data-id') : '';

    var nameList = '';
    var idList = '';
    var typeList = '';
    var requiredList = '';
    var genComList = '';
    var genComRequired = $('.gen-list-popup-admin[data-admin="' + adminId + '"] .gen-list-popup-admin-gencom-required', popup).is(':checked');

    var extraData = '';
    var itemTitleFromFieldId = $('.gen-list-popup-admin[data-admin="' + adminId + '"] .gen-list-popup-admin-title-select', popup).val();
    var genComValue = $('.gen-list-popup-admin[data-admin="' + adminId + '"] .gen-list-popup-admin-gencom', popup).val();

    items.each(function (i) {
        var tItem = $(this);
        var tType = $('.gen-list-popup-admin-item-type', tItem);
        var itemId = $('.gen-list-popup-admin-item-id', tItem).val();

        if (i !== 0) {
            nameList += ',';
            idList += ',';
            typeList += ',';
            requiredList += ',';
            genComList += ',';
            extraData += ',';
        }

        nameList += $('.gen-list-popup-admin-item-header-title', tItem).html();
        idList += itemId;
        typeList += tType.val();
        requiredList += $('.gen-list-popup-admin-item-required', tItem).is(':checked');
        genComList += $('.gen-list-popup-admin-item-gencom option:selected', tItem).val();

        if (tType.val() === 'text') {
            extraData += itemId + ':{';
            extraData += '"default-value":"';
            extraData += $('.gen-list-popup-admin-item-extra-text-prepopulate', tItem).val();
            extraData += '"';
            extraData += '}';
        } else if (tType.val() === 'bigtext') {
            extraData += itemId + ':{';
            extraData += '"default-value":"';
            extraData += $('.gen-list-popup-admin-item-extra-bigtext-prepopulate', tItem).val();
            extraData += '"';
            extraData += '}';
        } else if (tType.val() === 'select') {
            extraData += itemId + ':{';

            //Select json for the options values
            extraData += '"values":"';

            $('.gen-list-popup-admin-item-extra.select .gen-list-popup-admin-item-extra-select-item', tItem).each(function (s) {
                if (s !== 0) {
                    extraData += ',';
                }


                if ($('.gen-list-popup-admin-item-extra-select-inner-html', $(this)).val().length !== 0) {
                    extraData += $('.gen-list-popup-admin-item-extra-select-inner-html', $(this)).val();
                } else {
                    extraData += $('.gen-list-popup-admin-item-extra-select-text', $(this)).val();
                }
                extraData += ':';
                extraData += $('.gen-list-popup-admin-item-extra-select-text', $(this)).val();
            });
            extraData += '"';

            //Manage the multiple options value
            extraData += ', "multiple":"';
            extraData += $('.gen-list-popup-admin-item-extra-select-multiple', tItem).is(':checked');
            extraData += '"';

            // Manage the type if there are customSelects
            if ($('.gen-list-popup-admin-item-extra-select-select', tItem).length) {
                extraData += ', "type":"';
                extraData += $('.gen-list-popup-admin-item-extra-select-select', tItem).val();
                extraData += '"';
            }

            extraData += '}';
        } else if (tType.val() === 'checkbox') {
            extraData += itemId + ':{';

            //Select json for the options values
            extraData += '"values":"';

            $('.gen-list-popup-admin-item-extra.checkbox .gen-list-popup-admin-item-extra-select-item', tItem).each(function (s) {
                if (s !== 0) {
                    extraData += ',';
                }


                if ($('.gen-list-popup-admin-item-extra-select-inner-html', $(this)).val().length !== 0) {
                    extraData += $('.gen-list-popup-admin-item-extra-select-inner-html', $(this)).val();
                } else {
                    extraData += $('.gen-list-popup-admin-item-extra-select-text', $(this)).val();
                }
                extraData += ':';
                extraData += $('.gen-list-popup-admin-item-extra-select-text', $(this)).val();
            });
            extraData += '"';

            //Manage the multiple options value
            extraData += ', "number":"';
            extraData += $('.gen-list-popup-admin-item-extra-checkbox-number', tItem).val();
            extraData += '"';

            extraData += '}';
        } else if (tType.val() === 'file') {
            extraData += itemId + ':{';

            $('.gen-list-popup-admin-item-extra.file', tItem).each(function (f) {
                if (f !== 0) {
                    extraData += ',';
                }

                $('input', $(this)).each(function (k) {
                    if (k !== 0) {
                        extraData += ',';
                    }

                    extraData += $(this).attr('name') + ':"' + $(this).val() + '"';
                });
            });

            extraData += '}';
        } else if (tType.val() === 'gen-list') {
            extraData += itemId + ':{';

            $('.gen-list-popup-admin-item-extra.gen-list', tItem).each(function (f) {
                if (f !== 0) {
                    extraData += ',';
                }

                $('input', $(this)).each(function (k) {
                    if (k !== 0) {
                        extraData += ',';
                    }

                    extraData += $(this).attr('name') + ':"' + $(this).val() + '"';
                });
            });

            extraData += '}';
        } else if (tType.val() === 'icon') {
            extraData += itemId + ':{';
            extraData += $('.gen-list-popup-admin-item-extra-icon-input', tItem).val();
            extraData += '}';
        } else if (tType.val() === 'link') {
            extraData += itemId + ':{';
            extraData += '"default-value":"';
            extraData += $('.gen-list-popup-admin-item-extra-link-prepopulate', tItem).val();
            extraData += '"';
            extraData += '}';
        } else {
            extraData += '';
        }
    });


    var data = {
        "id": genId,
        "field1": 'gen-list-popup-admin',
        "field2": nameList,
        "field3": idList,
        "field4": typeList,
        "field5": requiredList,
        "field6": genComValue,
        "field7": genComValue.trim().length !== 0 ? genComList : '',
        "field8": genComRequired,
        "field10": itemTitleFromFieldId, //Value to be shown instead of "item X" in pannel
        "field11": popupId,
        "extraData": extraData,
        "ajax": 'true'
    };

    $.ajax({
        url: '/action/manageGenData',
        data: data,
        method: 'POST',
        cache: false,
        success: function (data) {
            if (data.indexOf('success') !== -1) {
                location.reload();
            }
        }
    });
}

function genListUpdateAdminItemsOrder(popup, autosave) {
    var id = popup.data('id');
    var adminId = popup.attr('data-admin-id');
    var popupId = adminId === undefined ? popup.attr('data-label-id') : adminId;
    var items = $('.gen-list-popup-admin[data-admin="' + popupId + '"] .gen-list-popup-admin-item:not(.clone)', popup);

    items.each(function (i) {
        $('.gen-list-popup-admin-item-header-title-num', $(this)).html(i + 1);
    });
}

function genListSaveAdminSelectAdd() {
    var t = $(this);
    var ctn = t.closest('.gen-list-popup-admin-item-extra.select, .gen-list-popup-admin-item-extra.checkbox');
    var list = $('.gen-list-popup-admin-item-extra-select-list', ctn);
    var clone = $('.gen-list-popup-admin-item-extra-select-item', ctn).eq(0).clone();

    $('.gen-list-popup-admin-item-extra-select-text', clone).val('');
    $('.gen-list-popup-admin-item-extra-select-inner-html', clone).val('');

    list.append(clone);
}

function genListSelectAdminSelectType(e) {
    var t = $(this);
    var ctn = t.closest('.gen-list-popup-admin-item-extra ');
    if (t.val() === '') {
        $('.gen-list-popup-admin-item-extra-select-list', ctn).removeClass('hidden');
        $('.gen-list-popup-admin-item-extra-select-add', ctn).removeClass('hidden');
    } else {
        $('.gen-list-popup-admin-item-extra-select-list', ctn).addClass('hidden');
        $('.gen-list-popup-admin-item-extra-select-add', ctn).addClass('hidden');
    }
}

function genListSaveAdminSelectDelItem() {
    var t = $(this);
    var item = t.closest('.gen-list-popup-admin-item-extra-select-item');
    item.remove();
}

function initGenListPopupAdminSelectSortable() {
    if ($('.gen-list-popup-admin-item-extra-select-handle').length !== 0) {
        $('.gen-list-popup-admin-item-extra-select-list').sortable({
            handle: ".gen-list-popup-admin-item-extra-select-handle",
            helper: fixHelper
        });
    }
}

function genListFilterMultipleSelectOptions() {
    $('.gen-list-popup-item-select-ctn[data-multi="true"]').each(function (e) {
        var ctn = $(this);

        $('.gen-list-popup-item-select option', ctn).each(function (s) {
            var currOption = $(this);
            var optionValue = currOption.attr('value');

            $('.gen-list-popup-item-select-selected-item:not(.clone)', ctn).each(function (v) {
                var currValItem = $(this);
                var currVal = $('.gen-list-popup-item-select-selected-item-val', currValItem).html();

                if (optionValue === currVal) {
                    currOption.hide();
                    return false;
                }
            });
        });
    });
}

function genListPopupItemSelectChange() {
    var input = $(this);
    var ctn = input.closest('.gen-list-popup-item-select-ctn');
    var list = $('.gen-list-popup-item-select-selected-ctn', ctn);
    var clone = $('.gen-list-popup-item-select-selected-item.clone', list);

    var val = input.val();
    var inner = $('option:selected', input).html();

    if (val.length !== 0) {
        $('option:selected', input).hide();

        var newElt = clone.clone().removeClass('clone');
        $('.gen-list-popup-item-select-selected-item-val', newElt).html(val);
        $('.gen-list-popup-item-select-selected-item-inner', newElt).html(inner);
        $('.gen-list-popup-item-select-selected-item-del', newElt).click(genListPopupItemSelectDel);
        list.append(newElt);
    }
}

function genListPopupItemSelectDel() {
    var t = $(this);
    var ctn = t.closest('.gen-list-popup-item-select-selected-item');
    var item = ctn.closest('.gen-list-popup-item-select-ctn');
    var val = $('.gen-list-popup-item-select-selected-item-val', ctn).html();

    $('.gen-list-popup-item-select option[value="' + val + '"]', item).show();
    ctn.remove();
}

function genListPopupAdminIconSelectChange() {
    var t = $(this);
    var val = t.val();
    var ctn = t.closest('.gen-list-popup-admin-item-extra.icon');
    var input = $('.gen-list-popup-admin-item-extra-icon-input', ctn);
    var inputVal = input.val();

    if (inputVal.length !== 0) {
        inputVal += ',';
    }

    inputVal += val;

    input.val(inputVal);
}

function genListSelectCountryChange() {
    var t = $(this);
    var val = t.val();
    var ctn = t.closest('.gen-list-popup-item-select-country-ctn');

    $('.gen-list-popup-item-select-state', ctn).removeClass('selected');

    if (val === 'CA' || val === 'CAN' || val === 'canada' || val === 'Canada') {
        $('.gen-list-popup-item-select-state.ca', ctn).addClass('selected');
    } else if (val === 'US' || val === 'USA' || val === 'United-States' || val === 'united-states') {
        $('.gen-list-popup-item-select-state.us', ctn).addClass('selected');
    } else {
        $('.gen-list-popup-item-select-state.other', ctn).addClass('selected');
    }
}

function genListUpdateTitle() {
    var t = $(this);
    var val = t.html();
    var ctn = t.closest('.gen-list-popup-admin-item-main-content');
    var idInput = $('.gen-list-popup-admin-item-id', ctn);

    if (idInput.val().length === 0) {
        idInput.val(formatStringForUrlHandle(val));
    }
}

//Function that searched thought the items value to do a partial match of the query
function genListSearch(e) {
    var t = $(this);
    var popup = t.closest('.gen-list-popup');
    var items = popup.find('> .picker-popup-window > .picker-popup-content > .popup-default-content-ctn > .gen-list-popup-list > .gen-list-popup-item');
    var regex = new RegExp(t.val().trim());

    items.each(function () {
        var that = $(this);
        var title = $('.gen-list-popup-item-header-title', that).text();

        if (!regex.test(title)) {
            that.css('display', 'none');
        } else {
            that.css('display', '');
        }
    });
}

//Tools for the Image Preview Picker
function filePreviewPickerSumbit(e) {
    var t = $(this);
    var popup = t.closest('.file-preview-picker-popup');
    var multi = popup.attr("data-multi");
    var main = $('.file-preview-picker-main-directory', popup);
    var itemSelected = $('.file-preview-picker-item:not(.folder).selected', popup);
    var value = '';
    var fullPathValue = '';
    if ($('.file-preview-picker-popup-selection-list', popup).length !== 0) {
        $('.file-preview-picker-popup-selection-item:not(.clone)', popup).each(function (index) {
            if (parseInt(index) !== 0) {
                value += ',';
                fullPathValue += ',';
            }

            fullPathValue += $(this).attr('data-url');
            value += $(this).attr('data-url');
        });
    } else {
        $.each(JSON.parse($(this).attr('data-value')), function (index, item) {
            if (parseInt(index) !== 0) {
                value += ',';
                fullPathValue += ',';
            }

            fullPathValue += this.fullUrl;
            value += this.fullUrl;
        });
    }
    var elementToUpdate = $(t.attr('data-element-to-update'));
    var typeOfUpdate = t.attr('data-type-of-update');
    var valueToUpdate = t.attr('data-value-to-update');
    var dataUpdateLabel = t.data('updateLabel');
    var updateElementValue = $(t.data('updateElementValue'));
    var updateLabelWithFullPath = t.data('updateLabelWithFullPath');
    var labelId = popup.attr('data-label-id');
    var lang = popup.attr('data-curr-lang');
    var langs = popup.attr('data-all-langs') || popup.attr('data-all-lang');
    var updateInAllLangs = t.data('updateLabelInAllLangs');
    var useNamehashOnly = t.data('useNamehashOnly');
    var itemNamehash = itemSelected.attr('data-hashname');
    var fullBGUrl = 'url("' + fullPathValue + '")';
    if (useNamehashOnly) {
        value = itemNamehash;
    } else if (updateLabelWithFullPath === true && multi !== 'true') {
        value = fullPathValue;
    }

    if (itemSelected.length === 0) {
        value = '';
        fullPathValue = '';
        fullBGUrl = '';
    }

    try {
        var mappedValues = JSON.parse(t.attr('data-value')).map(function (item) {
            return item.value;
        });
        var mappedPaths = JSON.parse(t.attr('data-value')).map(function (item) {
            return item.fullUrl;
        });
        fullPathValue = mappedPaths.join();

        value = useNamehashOnly ? JSON.parse(t.attr('data-value'))[0].hash : fullPathValue;
        fullBGUrl = 'url("' + JSON.parse(t.attr('data-value'))[0].fullUrl + '")';
    } catch (e) {

    }

    // An HTLM attribute or a CSS property can be updated with the image url
    if (typeOfUpdate === 'attribute') {
        elementToUpdate.attr(valueToUpdate, fullPathValue);
    } else if (typeOfUpdate === 'property') {
        elementToUpdate.css(valueToUpdate, fullBGUrl);
    } else if (typeOfUpdate === 'val') {
        elementToUpdate.val(fullPathValue);
        elementToUpdate.trigger('change');
    } else if (typeOfUpdate === 'text') {
        elementToUpdate.text(fullPathValue);
    }
    elementToUpdate.attr("data-preview-item-id", value);
    elementToUpdate.trigger("file-picker-change", {
        fullPathValue: fullPathValue,
        fullBGUrl: fullBGUrl,
        useNamehashOnly: useNamehashOnly,
        value: value
    });

    // An HTML element value can be updated with the filename of the image
    if (updateElementValue.length) {
        updateElementValue.html(value.substr(value.lastIndexOf("/") + 1));
    }
    // A sitelabel can be updated if the data-update-label is "true"
    if (dataUpdateLabel) {
        var langVal = updateInAllLangs ? langs : lang;
        var callback = function () {};

        if (e.data !== undefined && e.data !== null) {
            if (e.data.callback !== undefined) {
                callback = typeof e.data.callback === "function" ? e.data.callback() : function () {};
            }
        }

        updateLabelLangs(labelId, value, langVal, callback, false, false);
    }

    //Close the pupop with the custom function for the image-picker callback
    filePreviewPickerClosePopup.apply(t);
}

function filePreviewPickerItemClick() {
    var t = $(this);
    var ctn = t.closest('.file-preview-picker-popup-inner');
    var popup = t.closest('.file-preview-picker-popup');
    var multi = popup.attr('data-multi') === 'true';
    var required = ctn.data('required');
    var main = $('.file-preview-picker-main-directory', popup);
    var btn = $('.file-preview-picker-popup-accept-btn', popup);
    var hasDetailPanel = popup.attr('data-detail-panel') === 'true';
    var currUrl = t.attr('data-file-url') + t.attr('data-value');
    //Manages the selected option
    //If the option of multiple selectable image should be integrated, here is the place!
    if (t.hasClass('selected')) {
        if (!required || required && $('.file-preview-picker-item.selected', ctn).length > 1) {
            t.removeClass('selected');

            $('.file-preview-picker-popup-selection-item[data-url="' + currUrl + '"]', popup).remove();

            var data = {};
            $.each($('.file-preview-picker-item.selected:not(.folder)', ctn), function (index, item) {
                var fileUrlSeparator = $(item).attr('data-file-url').charAt($(item).attr('data-file-url').length - 1) === '/' ? '' : '/';

                data[index] = {
                    fullUrl: $(item).attr('data-file-url') + fileUrlSeparator + $(item).attr('data-value'),
                    value: $(item).attr('data-value'),
                    hash: $(item).attr('data-hashname')
                };
            });
            btn.attr('data-value', JSON.stringify(data));

            if (!multi || (multi && ('.file-preview-picker-item.selected:not(.folder)', ctn).length === 0 && main.attr('data-use-ajax') === 'false')) {
                $('.file-preview-picker-item.folder', ctn).removeClass('selected');
            } else if (multi && main.attr('data-use-ajax') === 'true') {
                $('.file-preview-picker-item.selected.folder', ctn).each(function () {
                    var f = $(this);
                    var fId = f.attr('data-id');
                    var found = false;
                    var fileUrlSeparator = f.attr('data-file-url').charAt(f.attr('data-file-url').length - 1) === '/' ? '' : '/';
                    var folderVal = f.attr('data-file-url') + fileUrlSeparator + f.attr('data-value');
                    if ($('.file-preview-picker-directory[data-id="' + fId + '"]', popup).hasClass('items-loaded')) {
                        $.each(JSON.parse(btn.attr('data-value')), function (index, file) {
                            if (file.fullUrl.indexOf(folderVal) != -1) {
                                found = true;
                                return false;
                            }
                        });
                        if (!found) {
                            f.removeClass('selected');
                        }
                    }
                });
            }
        }
    } else {
        if (!multi) {
            $('.file-preview-picker-item.selected', ctn).removeClass('selected');
            $('.file-preview-picker-popup-selection-item:not(.clone)', popup).remove();
        }

        t.addClass('selected');

        var data = JSON.parse(btn.attr('data-value'));
        $.each($('.file-preview-picker-item.selected:not(.folder)', ctn), function (index, item) {
            var fileUrlSeparator = $(item).attr('data-file-url').charAt($(item).attr('data-file-url').length - 1) === '/' ? '' : '/';

            data[index] = {
                fullUrl: $(item).attr('data-file-url') + fileUrlSeparator + $(item).attr('data-value'),
                value: $(item).attr('data-value'),
                hash: $(item).attr('data-hashname')
            };
        });
        btn.attr('data-value', JSON.stringify(data));

        $('.file-preview-picker-item.folder', ctn).each(function () {
            var f = $(this);
            var fId = f.attr('data-id');
            var fCtn = f.closest('.file-preview-picker-main-directory');
            var fCurrentDirectory = $('.file-preview-picker-directory[data-id="' + fId + '"]', fCtn);
            if ($('.file-preview-picker-item:not(.folder).selected', fCurrentDirectory).length !== 0) {
                f.addClass('selected');
            }
        });

        if ($('.file-preview-picker-popup-selection-item[data-url="' + currUrl + '"]', popup).length === 0) {
            var newPanelItem = $('.file-preview-picker-popup-selection-item.clone', popup).clone().removeClass('clone');
            newPanelItem.attr('data-url', currUrl);
            $('.file-preview-picker-popup-selection-title', newPanelItem).text(currUrl);

            $('.file-preview-picker-popup-selection-list', popup).append(newPanelItem);
        }
    }

    filePreviewCheckDetailTabCounter(popup);
}

function filePreviewCheckDetailTabCounter(popup) {
    var count = $('.file-preview-picker-popup-selection-item:not(.clone)', popup).length;
    $('.file-preview-picker-selection-count', popup).text(count);
}

function filePreviewPickerClosePopup() {
    var t = $(this);
    var popup = t.closest('.picker-popup');
    var searchInput = $('.file-preview-picker-input', popup);
    var items = $('.file-preview-picker-item', popup);

    //Callbacks the clear the serch filter when the popup is done closing
    pickerClosePopup.call(t, function () {
        items.show();
        searchInput.val('');
    });
}

//Function that searched thought the items value to do a partial match of the query
function filePreviewPickerSearch(e) {
    var t = $(this);
    var popup = t.closest('.file-preview-picker-popup');
    var items = $('.file-preview-picker-item:not(.clone)', popup);
    var regex = new RegExp(t.val().trim());

    items.each(function () {
        var that = $(this);
        var id = that.data('value');
        var itemParent = that.closest('.file-preview-picker-item-big');

        if (!regex.test(id)) {
            if (that.hasClass('selected')) {
                that.removeClass('selected');
            }
            itemParent.css('display', 'none');
        } else {
            itemParent.css('display', '');
        }
    });
}

function filePreviewPickerDirectoryOpen() {
    var t = $(this);
    var id = t.attr('data-id');
    var ctn = t.closest('.file-preview-picker-popup-inner');
    var bigCtn = ctn.closest('.picker-popup-content');
    var folder = $('.file-preview-picker-directory[data-id="' + id + '"]', ctn);
    var directory = $('.file-preview-picker-current-directory', bigCtn);
    var main = $('.file-preview-picker-main-directory', bigCtn);

    var tW = t.width();
    var tH = t.height();
    var tTop = t.position().top;
    var tLeft = t.position().left;

    var tPosTop = (tTop + tH / 2);
    var tPosLeft = (tLeft + tW / 2);
    var ctnW = ctn.width();
    var ctnH = ctn.height();
    var tPersTop = (tPosTop * 100) / ctnH;
    var tPersLeft = (tPosLeft * 100) / ctnW;

    folder.stop(true, true);

    directory.html(t.attr('data-directory-to-open'));
    folder.css({visibility: 'visible', top: tPersTop + '%', left: tPersLeft + '%'});

    if (main.attr('data-use-ajax') === 'true') {
        filePickerLoadDirectory(t.attr('data-directory-to-open'), folder);
    }

    folder.animate({top: '0%', left: '0%'}, 500, function () {
        folder.parents('.file-preview-picker-directory').add(folder.parents('.file-preview-picker-main-directory')).addClass('child-folder-open');
    });
    folder.addClass('show');
}

function filePreviewPickerDirectoryClose() {
    var t = $(this);
    var id = t.attr('data-id');
    var ctn = t.closest('.file-preview-picker-popup-inner');
    var bigCtn = ctn.closest('.picker-popup-content');
    var btn = $('.file-preview-picker-item.folder[data-id="' + id + '"]', ctn);
    var folder = $('.file-preview-picker-directory[data-id="' + id + '"]', ctn);
    var directory = $('.file-preview-picker-current-directory', bigCtn);
    var main = $('.file-preview-picker-main-directory', bigCtn);

    var tW = btn.width();
    var tH = btn.height();
    var tTop = btn.position().top;
    var tLeft = btn.position().left;

    var tPosTop = (tTop + tH / 2);
    var tPosLeft = (tLeft + tW / 2);
    var ctnW = ctn.width();
    var ctnH = ctn.height();
    var tPersTop = (tPosTop * 100) / ctnH;
    var tPersLeft = (tPosLeft * 100) / ctnW;

    folder.parent('.file-preview-picker-directory').removeClass('child-folder-open');
    if (folder.parent('.file-preview-picker-directory').length === 0) {
        folder.parent('.file-preview-picker-main-directory').removeClass('child-folder-open');
    }

    directory.html(btn.attr('data-directory-parent'));
    folder.animate({top: tPersTop + '%', left: tPersLeft + '%'}, 500, function () {
        folder.css('visibility', 'none');
    });
    folder.removeClass('show');
}

function filePreviewPickerHandleDrop(e) {
    e.preventDefault();
    // This function can be called by a file input or a droppable element
    var it = this;
    var $loadingBar = $('.status', it);
    var $fileInp = $(it).closest('.file-preview-picker-popup-upload').find('input[type=file]');
    var fileAccept = $fileInp.attr('accept') ? $fileInp.attr('accept').split(',') : undefined;
    var $popup = $(it).closest('.file-preview-picker-popup');
    var $currDir = $popup.find('.file-preview-picker-main-directory, .file-preview-picker-directory.show').filter(':not(.child-folder-open)');
    // Go through the originalEvent which contains the dataTransfer from drop
    var files = it.files || e.originalEvent.dataTransfer.files;
    var data = new FormData();
    
    for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var ext = file.name.substring(file.name.lastIndexOf('.'));
        if (!fileAccept || fileAccept.indexOf(ext) > -1 || fileAccept.indexOf(file.type) > -1) {
            var reader = new FileReader();
            data.append('bulk[]', file);
            reader.readAsDataURL(file);
            $loadingBar.css('width', ((100 / files.length) * i) + "%");
        }
    }
    if (!data.get('bulk[]')) {
        // None accepted file, process halted
        // Reset
        $loadingBar.css('width', '0');
        if (it.getAttribute('type') !== 'file') {
            it.style.backgroundColor = 'mistyRose';
        }
        return false;
    }
    data.append('dir', $currDir.attr('data-directory'));
    data.append('pageName', window.location.pathname.replace(/^\//, ''));
    data.append('ajax', "true");
    $.ajax({
        url: '/action/uploadMedia',
        type: 'POST',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        success: function (response) {
            $loadingBar.css('width', "100%").delay(310).css('opacity', '0').delay(310).css('width', '').delay(310).css('opacity', '');
            if (it.getAttribute('type') !== 'file') {
                it.style.backgroundColor = '';
            }
            $currDir.removeClass('items-loaded');
            filePickerLoadDirectory($currDir.attr('data-directory'), $currDir, true);
        },
        error: function (response) {
            console.error(response);
        }
    });
}

//Color Picker
var CPhslToRgb = function (ctn) {
    var light = ctn.attr('data-light') * 1;
    var saturation = ctn.attr('data-saturation') * 1;
    var hue = ctn.attr('data-hue') * 1;

    var r, g, b;
    var h = hue / 360, s = !isNaN(saturation) ? saturation : 1, l = light;

    if (s === 0) {
        r = g = b = l; // achromatic
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = CPhue2rgb(p, q, h + 1 / 3);
        g = CPhue2rgb(p, q, h);
        b = CPhue2rgb(p, q, h - 1 / 3);
    }

    return '#' + CPnumToHex(Math.round(r * 255)) + CPnumToHex(Math.round(g * 255)) + CPnumToHex(Math.round(b * 255));
};

var CPhue2rgb = function (p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
};

var CPrgbToHsl = function (r, g, b) {
    var max, min, h, s, l;

    r /= 255;
    g /= 255;
    b /= 255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max == min) {
        h = s = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }

    return [h, s, l];
};
/**
 * END OF FUNCTIONS TAKEN FROM: http://axonflux.com/handy-rgb-to-hsl-and-rgb-to-hsv-color-model-c
 */

/**
 * UTILITY FUNCTIONS
 */
var CPnumToHex = function (num) {
    var val = num.toString(16);
    return val.length === 1 ? 0 + val : val;
};

var CPclampValue = function (val, min, max) {
    return Math.min(Math.max(val, min), max);
};

/**
 * END OF UTILITY FUNCTIONS
 */

var CPsetColor = function (targetCtn, color) {
    if (typeof targetCtn !== 'undefined') {
        var target = targetCtn || $('.color-picker-color-picker-ctn');
        target.each(function () {
            var ctn = $(this);
            var colorCanvas = $('.color-picker-color-picker', ctn);
            var hueCanvas = $('.color-picker-hue-picker', ctn);
            if (color.length) {
                ctn.attr('data-current-color', color);
            }
            var hex = ctn.attr('data-current-color');
            var hexVal = hex.charAt(0) === '#' ? hex.substr(1) : hex;
            var r = parseInt(hexVal.substr(0, 2), 16);
            var g = parseInt(hexVal.substr(2, 2), 16);
            var b = parseInt(hexVal.substr(4, 2), 16);
            var hslValues = CPrgbToHsl(r, g, b);
            var hsvValue, hsvSaturation;

            var hue = hslValues[0] * 360;
            ctn.attr('data-hue', hue);

            var saturation = hslValues[1];
            ctn.attr('data-saturation', saturation);

            var light = hslValues[2];
            ctn.attr('data-light', light);
            hsvValue = (light * 2 + saturation * (1 - Math.abs(light * 2 - 1))) / 2;
            hsvSaturation = (2 * (hsvValue - light)) / hsvValue;
            ctn.attr('data-hue-color', 'hsl(' + hue + ', 100%, 50%)');

            CPsetupColorCanvas(colorCanvas);
            CPupdateHue(hslValues[0] * hueCanvas[0].height, hueCanvas);
            CPupdateColor(hsvSaturation * colorCanvas[0].width, (1 - hsvValue) * colorCanvas[0].height, colorCanvas);
        });
    }
};

var CPclearCanvasListeners = function () {
    $('.color-picker-color-picker').off('mousedown', CPstartDragColor);
    $('.color-picker-hue-picker').off('mousedown', CPstartDragHue);
};

var CPsetupCanvasListeners = function () {
    $('.color-picker-color-picker').on('mousedown', CPstartDragColor);
    $('.color-picker-hue-picker').on('mousedown', CPstartDragHue);
    $('.color-picker-color-current').on('click', CPcopyColor);
};

var CPsetupColorCanvas = function (colorCanvas) {
    var ctx = colorCanvas[0].getContext('2d');

    CPpaintColorCanvas(ctx, colorCanvas);
};

var CPpaintColorCanvas = function (ctx, colorCanvas) {
    var ctn = colorCanvas.closest('.color-picker-color-picker-ctn');
    ctx.fillStyle = ctn.attr('data-hue-color');
    ctx.fillRect(0, 0, colorCanvas[0].width, colorCanvas[0].height);

    CPpaintWhiteGradient(ctx, colorCanvas);
    CPpaintBlackGradient(ctx, colorCanvas);
};

var CPpaintWhiteGradient = function (ctx, colorCanvas) {
    var whiteGradient = ctx.createLinearGradient(0, 0, colorCanvas[0].width, 0);
    whiteGradient.addColorStop(0, '#fff');
    whiteGradient.addColorStop(1, 'transparent');
    ctx.fillStyle = whiteGradient;
    ctx.fillRect(0, 0, colorCanvas[0].width, colorCanvas[0].height);
};

var CPpaintBlackGradient = function (ctx, colorCanvas) {
    var blackGradient = ctx.createLinearGradient(0, 0, 0, colorCanvas[0].height);
    blackGradient.addColorStop(0, 'transparent');
    blackGradient.addColorStop(1, '#000');
    ctx.fillStyle = blackGradient;
    ctx.fillRect(0, 0, colorCanvas[0].width, colorCanvas[0].height);
};

var CPsetupHueCanvas = function () {
    var hueCanvas = $('.color-picker-hue-picker');

    hueCanvas.each(function () {
        var t = $(this);

        var ctx = t[0].getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, t[0].height);

        gradient.addColorStop(0, 'hsl(0, 100%, 50%)');
        gradient.addColorStop(0.17, 'hsl(61.2, 100%, 50%)');
        gradient.addColorStop(0.33, 'hsl(118.8, 100%, 50%)');
        gradient.addColorStop(0.50, 'hsl(180, 100%, 50%)');
        gradient.addColorStop(0.67, 'hsl(241.2, 100%, 50%)');
        gradient.addColorStop(0.83, 'hsl(298.8, 100%, 50%)');
        gradient.addColorStop(1, 'hsl(360, 100%, 50%)');

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, t[0].width, t[0].height);
    });
};

var CPstartDragColor = function (e) {
    var currentCPDraggedColor = $(this);
    e.preventDefault();

    CPmoveDragColor(e, currentCPDraggedColor);

    $(window).on('mousemove', {colorCanvas: currentCPDraggedColor}, CPmoveDragColor);
    $(window).on('mouseup', {colorCanvas: currentCPDraggedColor}, CPstopDragColor);
};

var CPmoveDragColor = function (e, elem) {
    var colorCanvas = elem || e.data.colorCanvas;
    var rect = colorCanvas[0].getBoundingClientRect();
    var positionX = e.clientX - rect.left;
    var positionY = e.clientY - rect.top;
    var clampedX = CPclampValue(positionX, 0, colorCanvas[0].width);
    var clampedY = CPclampValue(positionY, 0, colorCanvas[0].height);

    CPupdateColor(clampedX, clampedY, colorCanvas);
};

var CPstopDragColor = function (data) {
    $(window).off('mousemove', CPmoveDragColor);
    $(window).off('mouseup', CPstopDragColor);
};

// @NOTE: HSL calculations based on http://codeitdown.com/hsl-hsb-hsv-color/.
var CPupdateColor = function (x, y, colorCanvas) {
    var ctn = colorCanvas.closest('.color-picker-color-picker-ctn');
    var currentColor = ctn.attr('data-current-color');
    var currentColorCtn = $('.color-picker-color-current', ctn);
    var colorCursor = $('.color-picker-color-cursor', ctn);
    var ctx = colorCanvas[0].getContext('2d');
    var hsvValue, hsvSaturation;

    hsvValue = 1 - y / colorCanvas[0].height;
    hsvSaturation = x / colorCanvas[0].width;
    var light = (hsvValue / 2) * (2 - hsvSaturation);
    ctn.attr('data-light', light);
    ctn.attr('data-saturation', (hsvValue * hsvSaturation) / (1 - Math.abs(light * 2 - 1)));
    ctn.attr('data-current-color', CPhslToRgb(ctn));

    currentColorCtn.css('background', currentColor);
    currentColorCtn.html(currentColor);

    colorCursor.css('top', y + "px");
    colorCursor.css('left', x + "px");
    colorCursor.css('background', currentColor);

    colorCursor.attr('data-x', x);
    colorCursor.attr('data-y', y);
};

var CPstartDragHue = function (e) {
    var currentCPDraggedHue = $(this);
    e.preventDefault();

    CPmoveDragHue(e, currentCPDraggedHue);

    $(window).on('mousemove', {hueCanvas: currentCPDraggedHue}, CPmoveDragHue);
    $(window).on('mouseup', {hueCanvas: currentCPDraggedHue}, CPstopDragHue);
};

var CPmoveDragHue = function (e, elem) {
    var hueCanvas = elem || e.data.hueCanvas;
    var rect = hueCanvas[0].getBoundingClientRect();
    var positionY = e.clientY - rect.top;
    var clampedY = CPclampValue(positionY, 0, hueCanvas[0].height);

    CPupdateHue(clampedY, hueCanvas);
};

var CPstopDragHue = function (e) {
    $(window).off('mousemove', CPmoveDragHue);
    $(window).off('mouseup', CPstopDragHue);
};

var CPupdateHue = function (y, hueCanvas) {
    var ctn = hueCanvas.closest('.color-picker-color-picker-ctn');
    var colorCanvas = $('.color-picker-color-picker', ctn);
    var hueCursor = $('.color-picker-hue-cursor', ctn);
    var colorCursor = $('.color-picker-color-cursor', ctn);

    var ctx = hueCanvas[0].getContext('2d');
    var colorX = colorCursor.attr('data-x') | 0;
    var colorY = colorCursor.attr('data-y') | 0;

    var hue = y / hueCanvas[0].height * 360;
    ctn.attr('data-hue', hue);

    ctn.attr('data-hue-color', 'hsl(' + hue + ', 100%, 50%)');
    CPpaintColorCanvas(colorCanvas[0].getContext('2d'), colorCanvas);
    CPupdateColor(colorX, colorY, colorCanvas);

    hueCursor.css('top', y + "px");
    hueCursor.css('background', ctn.attr('data-hue-color'));
};

var CPcopyColor = function (e) {
    var t = this;
    var ctn = $(this).closest('.color-picker-color-picker-ctn');
    var currentColor = ctn.attr('data-current-color');
    var copySupported = document.queryCommandSupported('copy');
    var currentlyFocusedElement = document.activeElement;

    if (copySupported) {
        var input = document.createElement('input');
        input.setAttribute('value', currentColor);
        t.appendChild(input);
        input.select();
        document.execCommand('copy');
        currentlyFocusedElement.focus();
        t.removeChild(input);
        t.classList.add('copied');
        CPupdateDataInput(currentColor, ctn);
        setTimeout(function () {
            t.classList.remove('copied');
        }, 2000);
    }
};

var CPupdateDataInput = function (c, ctn) {
    var current = $('.color-picker-color-current', ctn);
    var parent = current.closest('.popup-outer-ctn');
    var inpName = current.attr("data-inp");
    var inp = $("input[name=" + inpName + "]", parent);

    inp.attr("value", c);
    inp.css("background-color", c);

    var luminance = {r: 0.2126, g: 0.7152, b: 0.0722};
    var color = c; // your color
    var r = parseInt(color.substring(1, 3), 16);
    var g = parseInt(color.substring(3, 5), 16);
    var b = parseInt(color.substring(5), 16);
    var rgb = [r / 255, g / 255, b / 255];
    for (var i = rgb.length; i--; )
        rgb[i] =
                rgb[i] <= 0.03928 ?
                rgb[i] / 12.92 :
                Math.pow(((rgb[i] + 0.055) / 1.055), 2.4);
    var thresh = ((luminance.r * rgb[0]) +
            (luminance.g * rgb[1]) +
            (luminance.b * rgb[2]));

    if (thresh > 0.22) {
        inp.css("color", "black");
        inp.css("border-color", "black");
    } else {
        inp.css("color", "white");
        inp.css("border-color", "white");
    }

};


// ######
function fillRating(e, sel, half) {
    var t = $(sel);
    t.parent().addClass("rated");
    var pos = t.attr("data-pos");
    t.prevAll().addClass('full');
    if (pos !== '1') {
        if (half !== '') {
            t.addClass('half');
            t.prevAll().removeClass('half');
        } else {
            t.addClass('full');
        }
    } else if (pos === '1') {
        var w = $(sel).width();
        t.on("mousemove", function (e) {
            var m = getMouseOffset(sel, e);
            if (half === '' && m.x > (w / 4)) {
                t.addClass("full");
            } else if (m.x < (w / 2)) {
                t.prevAll().removeClass("half");
                t.removeClass("half");
                t.removeClass("full");
            } else {
                if (half !== '') {
                    t.addClass("half");
                }
            }
        });
    } else if (pos === '5') {
        var w = $(sel).width();
        t.on("mousemove", function (e) {
            var m = getMouseOffset(sel, e);
            if (m.x > (w / 2)) {
                t.prevAll().removeClass("half");
                t.removeClass("half");
                t.addClass("full");
            }
        });
    }
    t.prevAll().removeClass("half");
    t.nextAll().removeClass('full');
    t.nextAll().removeClass('half');
}
function stopHoverMousemove() {
    var t = $(this);
    t.off('mousemove');
}
function stopHoverRating(e, sel, half) {
    var t = $(sel);
    t.parent().addClass("rated");
    t.parent().find(".r-star").removeAttr("onmouseenter");
    t.parent().find(".r-star").unbind("mousemove");
    t.prevAll().addClass('full');
    var w = $(sel).width();
    var m = getMouseOffset(sel, e);
    if (half !== '') {
        if (m.x <= (w / 4)) {
            t.prevAll().removeClass("half");
            t.removeClass("half");
            t.removeClass("full");
        }
        if (m.x > (w / 4) && m.x < ((2 * w) / 3)) {
            t.removeClass("full");
            t.prevAll().removeClass("half");
            t.addClass('half');
        }
        if (m.x > ((2 * w) / 3)) {
            t.removeClass("half");
            t.addClass('full');
        }
    } else {
        t.addClass("full");
        if (m.x < (w / 3)) {
            t.removeClass("full");
        }
    }
    t.prevAll().removeClass("half");
    t.nextAll().removeClass('full');
    t.nextAll().removeClass('half');
}

function stoolPreviewOverlay(inp, sel, selectAll) {
    var targ;
    if (sel && sel !== "") {
        targ = $(sel);
        if (!selectAll) {
            targ = targ.first();
        }
    } else {
        targ = $(inp).parent().find(".stool-cover-overlay").first();
    }
    targ.css('opacity', inp.value);
}
function stoolUpdateOverlay(inp, callback) {
    var key = inp.getAttribute("data-key"),
            langs = inp.getAttribute("data-langs"),
            val = inp.value;

    updateLabelLangs(key, val, langs, callback, true);
}

function stoolOpenLEW(e, el) {
    openWindow("editSiteLink", true);

    var form = document.getElementById("editSiteLinkForm"),
            fields = form.elements,
            data = getDataSet(el),
            btn = document.getElementById("editSiteLinkBtn"),
            lang = lang || document.documentElement.lang,
            allLangs = data.allLangs,
            langs = $("html").attr("data-all-langs") || $("html").attr("data-all-lang"),
            list = ["type", "href", "target", "text", "query", "event", "custom"],
            successCd = list.length;

    if (lang.indexOf('-') !== -1) {
        lang = lang.split('-')[0];
    }
    if (data.customActive === 'false') {
        $(".custom-edit-link-toggle").css("display", "none");
    } else {
        $(".custom-edit-link-toggle").css("display", "block");
    }

    for (var i = 0; i < fields.length; i++) {
        var inp = fields[i],
                name = inp.name;

        if (inp.className.indexOf('edit-link-tab') !== -1) {
            if (inp.value === data[name]) {
                inp.checked = true;
                inp.onchange();
            }
        } else if (inp.type === "radio" || inp.type === "checkbox") {
            if (inp.value === data[name]) {
                inp.checked = true;
            } else {
                inp.checked = false;
            }
        } else {
            inp.value = data[name] ? data[name] : "";
        }
    }

    btn.onclick = function () {
        for (var i = 0; i < fields.length; i++) {
            var inp = fields[i],
                    name = inp.name,
                    val = inp.value;

            if (inp.className.indexOf('edit-link-tab') !== -1) {
                if (inp.checked) {
                    data[name] = val;
                    data.href = val !== "" ? fields.namedItem(val).value : "";
                    el.setAttribute("data-" + name, val);
                }
            } else if (inp.type === "radio" || inp.type === "checkbox") {
                if (inp.checked) {
                    data[name] = val;
                    el.setAttribute("data-" + name, val);
                } else {
                    data[name] = false;
                    el.setAttribute("data-" + name, false);
                }
            } else {
                data[name] = val;
                el.setAttribute("data-" + name, val);
                if (name === "page" && inp.selectedIndex > -1)
                    data.tag = inp.options[inp.selectedIndex].getAttribute("data-tag");
            }
        }

        for (var j = 0; j < list.length; j++) {
            var it = list[j];

            if (allLangs == "true" && langs && langs !== "") {
                updateLabelLangs(data.key + "." + it, data[it], langs, _complete);
            } else {
                updateLabel(data.key + "." + it, data[it], lang, _complete);
            }
        }
        closeWindow("editSiteLink");
    };

    function _complete() {
        if (--successCd <= 0) {
            var a = data.sel === "" ? el.nextElementSibling : document.querySelector(data.sel);
            if (a) {
                a.href = data.type === "" ? "javascript:void(0);"
                        : (data.type === "page" ? data.tag : data.href)
                        + (data.type !== "internal" ? data.query : "");
                if (!a.children[0]) {
                    a.innerHTML = data.text || a.getAttribute("data-text");
                }
                if (data.target === "") {
                    a.removeAttribute("target");
                    a.removeAttribute("rel");
                } else {
                    a.target = data.target;
                    a.rel = "noopener nofollow";
                }
                a.onclick = data.event === "" ? null
                        : function (e) {
                            e.preventDefault();
                            eval(data.event);
                        };
            }
        }
    }
}
function stoolToggleLinkInput(inp) {
    var form = inp.form,
            selA = form.elements.namedItem("page").parentElement,
            selB = form.elements.namedItem("internal").parentElement,
            selC = form.elements.namedItem("external").parentElement;

    selA.style.display = selB.style.display = selC.style.display = "none";
    if (inp.checked && inp.value !== "") {
        form.elements.namedItem(inp.value).parentElement.style.display = "block";
    }
}

function stoolOpenIconPicker(e, btn, callback) {
    var el = btn.nextElementSibling,
            ico = el.children[0],
            cls = el.getAttribute("data-class"),
            sl = el.getAttribute("data-save-label"),
            siv = el.getAttribute("data-show-icon-value"),
            windowId = btn.getAttribute("data-window-id"),
            ipw = document.getElementById(windowId),
            sel = ipw.getElementsByClassName("stool-icopick-icon")[0],
            btnOk = ipw.getElementsByClassName("button-primary")[0];

    if (ico && cls !== "") {
        sel = ipw.getElementsByClassName(cls)[0];
    }
    stoolSelectIcon(sel);
    btnOk.onclick = _confirm;
    openWindow(windowId);

    function _confirm() {
        var sel = ipw.querySelector(".stool-icopick-icon.selected"),
                newIco = sel.children[0],
                newCls = "",
                content = "",
                val = "";

        if (newIco && sel.hasAttribute("data-name")) {
            val = sel.getAttribute("data-name");
            newCls = "stool-i" + val;
            content = newIco.outerHTML;
        }
        el.setAttribute("data-class", newCls);
        if (siv === 'false') {
            el.innerHTML = content;
        } else {
            el.innerHTML = val;
        }
        if (sl === 'true') {
            updateLabelLangs(btn.getAttribute("data-key"), val,
                    btn.getAttribute("data-langs"), callback, true);
        }
        closeWindow(windowId);
    }
}
function stoolSelectIcon(sel) {
    var kc = "selected";
    if (!$(sel).hasClass(kc)) {
        var other = sel.parentElement.querySelector("." + kc);
        if (other)
            $(other).removeClass(kc);
        $(sel).addClass(kc);
    }
}

function socialPopupSubmitClick() {
    var t = $(this);
    var ctn = t.closest('.picker-popup');
    var items = $('.social-popup-item', ctn);
    var langs = ctn.attr('data-all-langs') || ctn.attr('data-all-lang');
    var siteList = '';
    var listLabel = 'social-list';

    items.each(function (i) {
        var k = $(this);
        var input = $('.social-popup-input', k);
        var id = input.attr('data-id');
        var hide = $('.social-popup-input-hide', k);
        var hideId = hide.attr('name');

        if (siteList !== '') {
            siteList += ',';
        }

        siteList += input.attr('data-accro');

        updateLabelLangs(id, input.val(), langs);
        updateLabelLangs(hideId, String(hide.is(':checked')), langs);
    });

    var complete = function () {
        window.location.reload();
    };

    updateLabelLangs(listLabel, siteList, langs, complete);
}

var fixHelper = function (e, ui) {
    ui.children().each(function () {
        $(this).width($(this).width());
    });
    return ui;
};

function initSocialSortable() {
    if ($('.social-popup-content .social-popup-draggable-handle').length !== 0) {
        $('.social-popup-content').sortable({
            handle: ".social-popup-draggable-handle",
            items: ".social-popup-item",
            helper: fixHelper
        });
    }
}

//SToolComponentSettings
function SToolComponentSettingsLinkSave() {
    // var linkType = $('.edit-link-tab:checked', l).val();
    // var linkHref = '';

    // if (linkType === 'page') {
    //     linkHref = $('select[name="page"]', l).val();
    // } else if (linkType === 'internal') {
    //     linkHref = $('input[name="internal"]', l).val();
    // } else if (linkType === 'external') {
    //     linkHref = $('input[name="external"]', l).val();
    // }

    // json[id] = JSON.stringify({
    //     type: linkType,
    //     href: linkHref,
    //     query: $('input[name="query"]', l).val(),
    //     event: $('input[name="event"]', l).val(),
    //     targ: $('select[name="target"]', l).val(),
    //     text: $('input[name="text"]', l).val()
    // });

    var ctn = $(this).closest('.stool-component-settings-item');
    var fieldId = $('.stool-link-edit-window-content', ctn).attr('data-field-id');
    var message = $('.stool-component-settings-save-message', ctn);


    var linkType = $('.edit-link-tab:checked', ctn).val();
    var linkHref = '';

    if (linkType === 'page') {
        linkHref = $('[name="page"]', ctn).val();
    } else if (linkType === 'internal') {
        linkHref = $('[name="internal"]', ctn).val();
    } else if (linkType === 'external') {
        linkHref = $('[name="external"]', ctn).val();
    }

    var fields = {
        type: linkType,
        href: linkHref,
        query: $('[name="query"]', ctn).val(),
        event: $('[name="event"]', ctn).val(),
        targ: $('[name="target"]', ctn).val(),
        text: $('[name="text"]', ctn).val()
    };

    var count = 0;
    var total = Object.keys(fields).length;



    $.each(fields, function (key, value) {
        updateLabel(fieldId + "." + key, value, $('html').attr('lang'), function () {
            count++;

            if (count === total) {
                message.addClass('show');

                setTimeout(function () {
                    message.removeClass('show');
                }, 2000);
            }
        });
    });
}


// Custom links
var openCustomLinks = function () {
    var id = $(this).attr("data-popup-id");
    openWindow(id, true);

};

var selectCustomLink = function () {
    var t = $(this);
    var id = t.attr("data-id");
    var ctn = t.closest(".windowMainContainer").find(".admin-section-links-chosen-ctn");
    if (t.hasClass("selected")) {
        t.removeClass("selected");
        ctn.find(".admin-custom-links-ctn[data-id = '" + id + "']").remove();
    } else {
        t.addClass("selected");
        createLink(ctn, id, t.attr("data-name"), t.attr("data-mainTag"));
    }
};

var createLink = function (ctn, id, text, href) {
    var link = $("#link-admin-copy").children().clone("true");
    link.attr("data-id", id);
    link.find(".admin-custom-selected-links").attr("href", href);
    link.find(".admin-custom-selected-links").html(text);

    ctn.append(link);
};

var addCustomLink = function () {
    var t = $(this);
    var form = t.closest(".admin-page-name-external");
    var ctn = t.closest(".windowMainContainer").find(".admin-section-links-chosen-ctn");

    var name = form.find("input[name='customText']").val();
    var link = form.find("input[name='customLink']").val();

    if (name.trim() !== '' && link.trim() !== '') {
        createLink(ctn, "", name, link);
        form.find("input[name='customText']").val("");
        form.find("input[name='customLink']").val("");
    }

};

var saveCustomLinks = function () {
    var t = $(this);
    var currWindow = t.closest('.foxoneWindow');
    var ids = "";
    var key = $(this).attr("data-label");
    var windowId = $(this).attr("data-window-id");
    // var langs = ($(this).attr("data-langs") !== undefined && $(this).attr("data-langs") !== "") ? $(this).attr("data-langs") : ["fr"];
    var lang = ($(this).attr("data-lang") !== undefined && $(this).attr("data-lang") !== "") ? $(this).attr("data-lang") : 'fr';

    $(".chosen-custom-links .admin-custom-links-ctn", currWindow).each(function () {
        var id = $(this).attr("data-id");
        if (id !== '') {
            ids += $(this).attr("data-id") + ",";
        } else {
            ids += $(this).find('.admin-custom-selected-links').attr("href") + "~!~" + $(this).find('.admin-custom-selected-links').html() + ",";
        }
    });

    ajax("/action/addSiteLabel?lang=" + lang + "&key=" + key +
            "&value=" + encodeURIComponent(ids), function () {
        closeWindow(windowId);
    }, true);
};

var initCustomLinksDraggable = function () {
    if ($(".admin-section-links-chosen-ctn").length > 0) {
        $(".admin-section-links-chosen-ctn").sortable({
            connectWith: ".admin-section-links-chosen-ctn",
            handle: ".admin-dragger"
        }).disableSelection();
    }
};

var delCustomLink = function () {
    var t = $(this);
    var ctn = t.closest(".admin-custom-links-ctn");
    var id = ctn.attr("data-id");
    var win = t.closest(".windowMainContainer");
    if (id !== '' && win.find(".admin-page-name.selected[data-id = " + id + "]").length !== 0) {
        win.find(".admin-page-name.selected[data-id = " + id + "]").removeClass("selected");
    }
    ctn.remove();
};
// ######

// doc: http://www.chartjs.org/docs/latest/
function initChartCanvas(id) {
    var ctx = $('#' + id);
    if (!ctx[0])
        return;

    var type = ctx.data('type');

    // CHART BACKGROUND
    var chartBackgroundColor1 = ctx.data('chart-background-color-1');
    var chartBackgroundColor2 = ctx.data('chart-background-color-2');

    // LEGEND
    var displayLegend = ctx.data('display-legend');
    var fontSize = ctx.data('font-size');
    var legendUsePointStyle = ctx.data('legend-label-use-point-style');
    var legendFontColor = ctx.data('legend-label-font-color');

    // X AXIS
    var chartXAxisLabels = ctx.data('x-axis-labels').split(',');
    var chartXDisplayGrid = ctx.data('x-display-gridlines');
    var chartXDisplayBorder = ctx.data('x-display-border');

    // Y AXIS
    var chartYAxisLabel = ctx.data('y-axis-label');
    var chartYAxisUnits = ctx.data('y-axis-units');
    var chartYAxisUnitsInt = ctx.data('y-axis-units-int');
    var chartYDisplayGrid = ctx.data('y-display-gridlines');
    var chartYDisplayBorder = ctx.data('y-display-border');
    var chartYBeginAtZero = ctx.data('y-begin-zero');
    var chartYToFixedValue = ctx.data('y-tofixed-value');

    // TOOLTIP
    var tooltipBackgroundColor = ctx.data('tooltip-bg-color');
    var tooltipBodyFontColor = ctx.data('tooltip-body-font-color');
    var tooltipBodyFontFamily = ctx.data('tooltip-body-font-family');
    var tooltipBodyFontStyle = ctx.data('tooltip-body-font-style');
    var tooltipBodyFontSize = ctx.data('tooltip-body-font-size');
    var tooltipXPadding = ctx.data('tooltip-x-padding');
    var tooltipYPadding = ctx.data('tooltip-y-padding');
    var tooltipCaretSize = ctx.data('tooltip-caret-size');
    var tooltipDisplayColors = ctx.data('tooltip-display-colors');
    var tooltipDisplayTitle = ctx.data('tooltip-display-title');

    // DATASETS
    var stacked = ctx.data('stacked');
    var datasets = ctx.data('datasets').split('*');
    var datasetsArr = [];
    datasets.forEach(function (element) {
        if (element.length !== 0) {
            datasetsArr.push(JSON.parse(element));
        }
    });

    var data = {
        labels: chartXAxisLabels,
        datasets: datasetsArr
    };

    var graphtoolTooltipData = {
        callbacks: {
            label: function (tooltipItems, data) {
                var graphTooltiplabel = '';
                if (data.datasets[tooltipItems.datasetIndex].label !== undefined) {
                    graphTooltiplabel += data.datasets[tooltipItems.datasetIndex].label + ': ';
                }
                if (tooltipItems.yLabel !== undefined) {
                    graphTooltiplabel += tooltipItems.yLabel;
                }
                if (chartYAxisUnits !== undefined) {
                    graphTooltiplabel += ' ' + chartYAxisUnits;
                }
                return graphTooltiplabel;
            }
        }
    };

    if (tooltipBackgroundColor) {
        graphtoolTooltipData.backgroundColor = tooltipBackgroundColor;
    }
    if (tooltipBodyFontColor) {
        graphtoolTooltipData.bodyFontColor = tooltipBodyFontColor;
    }
    if (tooltipBodyFontFamily) {
        graphtoolTooltipData.bodyFontFamily = tooltipBodyFontFamily;
    }
    if (tooltipBodyFontStyle) {
        graphtoolTooltipData.bodyFontStyle = tooltipBodyFontStyle;
    }
    if (tooltipBodyFontSize) {
        graphtoolTooltipData.bodyFontSize = tooltipBodyFontSize;
    }
    if (tooltipXPadding) {
        graphtoolTooltipData.xPadding = tooltipXPadding;
    }
    if (tooltipYPadding) {
        graphtoolTooltipData.yPadding = tooltipYPadding;
    }
    if (tooltipCaretSize) {
        graphtoolTooltipData.caretSize = tooltipCaretSize;
    }
    // hide color boxes if false
    if (tooltipDisplayColors !== undefined && !tooltipDisplayColors) {
        graphtoolTooltipData.displayColors = tooltipDisplayColors;
    }
    // hide title if false
    if (tooltipDisplayTitle !== undefined && !tooltipDisplayTitle) {
        graphtoolTooltipData.callbacks.title = function () {};
    }

    var options = {
        scales: {
            xAxes: [{
                    stacked: stacked,
                    gridLines: {
                        display: chartXDisplayGrid,
                        drawBorder: chartXDisplayBorder,
                        offsetGridLines: type === 'bar' ? true : false
                    }
                }],
            yAxes: [{
                    stacked: stacked,
                    scaleLabel: {
                        display: chartYAxisLabel.length ? true : false,
                        labelString: chartYAxisLabel,
                        fontSize: fontSize
                    },
                    gridLines: {
                        display: chartYDisplayGrid,
                        drawBorder: chartYDisplayBorder
                    },
                    ticks: {
                        beginAtZero: chartYBeginAtZero === true,
                        // Include a unit after the ticks
                        callback: function (value, index, values) {
                            if (chartYAxisUnits.trim().length) {
                                if (chartYAxisUnitsInt === false) {
                                    value = parseFloat(value.toFixed(chartYToFixedValue ? chartYToFixedValue : 10));
                                }
                                return value + ' ' + chartYAxisUnits;
                            } else {
                                if (chartYAxisUnitsInt === true) {
                                    if (value % 1 === 0) {
                                        return value;
                                    } else {
                                        return "";
                                    }
                                } else if (typeof chartYToFixedValue === 'number') {
                                    if (chartYToFixedValue === 0) {
                                        if (Math.floor(value) === value) {
                                            return value;
                                        }
                                    } else {
                                        return value.toFixed(typeof chartYToFixedValue === 'number' ? chartYToFixedValue : 10);
                                    }
                                } else {
                                    return value;
                                }
                            }
                        }
                    }
                }]
        },
        legend: {
            display: displayLegend,
            onClick: function () {
                return;
            },
            labels: {
                usePointStyle: legendUsePointStyle,
                fontSize: fontSize,
                fontColor: legendFontColor
            }
        },
        chartArea: {
            backgroundColor1: chartBackgroundColor1,
            backgroundColor2: chartBackgroundColor2
        },
        tooltips: graphtoolTooltipData
    };

    var myChart = new Chart(ctx, {
        type: type,
        data: data,
        options: options
    });
}

/*SHARED POPUP START*/
var stoolSharedPopupMouseDownTarget;
var openPopup = function (p) {
    var btn = $(this);
    var popups = $('.stool-shared-popup');
    var id = btn.attr('data-id');
    var popup = popups.filter('[data-id=' + id + ']');
    var visiblePopups = popups.filter('.visible');
    var removeScroll = !popup.hasClass("keep-scroll");

    if (visiblePopups.length) {
        popup.addClass('no-anim');
        visiblePopups.addClass('no-anim').removeClass('visible');
        // NOTE: Can't remove straight away because it will still animate partially.
        setTimeout(function () {
            visiblePopups.removeClass('no-anim');
        }, 100);
    } else {
        if (removeScroll) {
            var w1 = $('body').width();
            $('body').addClass('no-scroll');
            var w2 = $('body').width();
            $('body').css('padding-right', (w2 - w1) + 'px');
        }
    }

    popup.addClass('visible');
    popup.trigger('shared-popup-open', $(this));
};

var closePopup = function (e) {
    var popup;
    var isSameTarget = stoolSharedPopupMouseDownTarget && stoolSharedPopupMouseDownTarget.isEqualNode(e.target);

    if (isSameTarget && $(e.target).hasClass('stool-shared-popup-outer')) {
        popup = $(e.target);
    } else if (isSameTarget && ($(e.target).hasClass('stool-shared-popup-close-btn')
            || $(e.target).hasClass('stool-shared-popup-cancel-btn')
            || $(e.target).closest('.stool-shared-popup-cancel-btn').length > 0)) {
        popup = $(e.target).closest('.stool-shared-popup-outer');
    } else if ($(e.target).hasClass('stool-shared-popup-close-btn') && $(e.target).attr('data-id')) {
        popup = $('.stool-shared-popup[data-id=' + $(e.target).attr('data-id') + ']');
    }

    if (popup && (!popup.hasClass('no-close') || $(e.target).hasClass('stool-shared-popup-cancel-btn')
            || $(e.target).closest('.stool-shared-popup-cancel-btn').length > 0)) {
        if (!popup.hasClass("keep-scroll")) {
            $('body').removeClass('no-scroll');
            $('body').css('padding-right', '0px');
        }
        popup.removeClass('no-anim').removeClass('visible');

        if (popup.hasClass('stool-component-settings-popup')) {
            removeDarkenComponents();
        }
        popup.trigger('shared-popup-close');
    }
};

var closePopupById = function (id) {
    var popup = document.getElementById(id);
    closePopup({
        target: popup
    });
};

var openPopupById = function (id) {
    var div = $('<div />');
    div.attr('data-id', id);
    openPopup.apply(div);
};

var sharedPopupMouseDown = function (e) {
    stoolSharedPopupMouseDownTarget = e.target;
};
/*SHARED POPUP END*/

var darkenOtherComponents = function () {
    var id = $(this).attr('data-id');

    $('.componentContainerDiv').each(function () {
        if ($(this).attr('id') !== 'componentDiv_' + id) {
            $(this).addClass('darken');
        }
    });
};

var removeDarkenComponents = function () {
    $('.componentContainerDiv').removeClass('darken');
};

var changeURLState = function (q, x, state, title) {
    var qs = "";
    var url = window.location.pathname;

    if (!q || typeof q !== "string") {
        return null;
    }

    if (x === null || x === undefined) {
        qs = removeQuery(q);
    } else {
        qs = setQuery(q, x);
    }
    if (qs !== "") {
        qs = "?" + qs;
    }
    url += qs + window.location.hash;

    return window.history.pushState(state, (title ? title : q + " " + x), url);
};

var removeQuery = function (param, search) {
    var se = search !== undefined ? search : window.location.search;
    if (!param || param === "")
        return se.replace("?", "");

    var qa = se.replace("?", "").split("&");
    var qa2 = [];
    for (var i = 0; i < qa.length; i++) {
        var qi = qa[i];
        var j = qi.indexOf("=");
        var qname = j > -1 ? qi.substring(0, j) : qi;

        if (qname !== param)
            qa2.push(qi);
    }

    return qa2.join("&");
};

var setQuery = function (param, value, search) {
    var se = search !== undefined ? search : window.location.search;
    var v = encodeURIComponent(value);
    if (se !== "") {
        var qa = se.replace("?", "").split("&");
        var qa2 = [];
        var isNew = true;

        for (var i = 0; i < qa.length; i++) {
            var qi = qa[i];
            var j = qi.indexOf("=");
            var qname = j > -1 ? qi.substring(0, j) : qi;
            if (qname === param) {
                if (v && v !== "") {
                    qi = param + "=" + v;
                } else {
                    qi = param;
                }
                isNew = false;
            }
            qa2.push(qi);
        }
        if (isNew)
            qa2.push(param + "=" + v);

        return qa2.join("&");
    } else if (v && v !== "") {
        return param + "=" + v;
    } else {
        return param;
    }
};

var updateTab = function (e) {
    var tab = e.state ? e.state.t : tabState.t;
    var family = e.state ? e.state.tf : tabState.tf;
    $('.stool-shared-tab[data-tab-family="' + family + '"]').removeClass('selected');
    $('.stool-shared-tab[data-tab-family="' + family + '"][data-tab="' + tab + '"]').addClass('selected');
    $('.stool-shared-tab-ctn[data-tab-family="' + family + '"]').removeClass('selected');
    $('.stool-shared-tab-ctn[data-tab-family="' + family + '"][data-tab="' + tab + '"]').addClass('selected');
};

var changeTab = function () {
    var t = $(this);
    var tab = t.attr('data-tab');
    var family = t.attr('data-tab-family');
    var allClass = t.attr('data-all-class');
    var changeUrlWithParam = t.attr('data-change-url-with-param') === 'true';

    $('.stool-shared-tab[data-tab-family="' + family + '"]').removeClass('selected');
    t.addClass('selected');

    $('.stool-shared-tab-ctn[data-tab-family="' + family + '"]').removeClass('selected');
    if (tab != allClass) {
        $('.stool-shared-tab-ctn[data-tab-family="' + family + '"][data-tab="' + tab + '"]').addClass('selected');
    } else {
        $('.stool-shared-tab-ctn[data-tab-family="' + family + '"]').addClass('selected');
    }

    if (changeUrlWithParam) {
        tabState = {t: tab, tf: family};
        changeURLState('t', tab, Object.assign({}, tabState));
    }
};

var compSettingsCheckboxUpdateLabel = function () {
    var t = $(this);
    var label = t.attr('name');
    var val = t.is(':checked') ? t.is(':checked') : '';
    var langs = $('html').attr('data-all-langs') || $('html').attr('data-all-lang');

    if (t.attr('type') === 'radio') {
        val = t.attr('value');
    }

    updateLabelLangs(label, val, langs, function () {}, true);
};

var compSettingsFocusCheck = function (e) {
    $(e.delegateTarget).find('.stool-component-settings-checkbox-input').prop('checked', true);
};

var compSettingsSelectUpdateLabel = function () {
    var t = $(this);
    var label = t.attr('name');
    var val = t.val();
    var langs = $('html').attr('data-all-langs') || $('html').attr('data-all-lang');

    updateLabelLangs(label, val, langs, function () {}, true);
};

var compSettingsEditableLabelUpdate = function () {
    var t = $(this);
    var ctn = t.closest('.stool-component-settings-item-label');
    var ta = $('.stool-component-settings-item-label-input', ctn);
    var message = $('.stool-component-settings-item-label-message', ctn);

    updateLabelLangs(ta.attr('data-key'), ta.val(), $('html').attr('lang'), function () {
        message.addClass('show');

        setTimeout(function () {
            message.removeClass('show');
        }, 2000);
    }, true);
};

var compSettingsEditableMCEUpdate = function () {
    var t = $(this);
    var ctn = t.closest('.stool-component-settings-item-label');
    var ta = $('.stool-component-settings-item-mce-input', ctn);
    var message = $('.stool-component-settings-item-label-message', ctn);
    var val = tinymce.get($('.stool-component-settings-item-mce-input', ctn).attr('id')).getContent();

    updateLabelLangs(ta.attr('data-key'), val, $('html').attr('lang'), function () {
        message.addClass('show');

        setTimeout(function () {
            message.removeClass('show');
        }, 2000);
    }, true);
};

var compSettingsEditableLabelMoreHeight = function () {
    var t = $(this);
    var ctn = t.closest('.stool-component-settings-item-label');
    var ta = $('.stool-component-settings-item-label-input', ctn);
    var lh = parseFloat(ta.css('line-height'));
    var lessBtn = $('.stool-component-settings-item-label-input-less', ctn);

    ta.height(ta.height() + (lh * 3));
    lessBtn.prop('disabled', false);
};

var compSettingsEditableLabelLessHeight = function () {
    var t = $(this);
    var ctn = t.closest('.stool-component-settings-item-label');
    var ta = $('.stool-component-settings-item-label-input', ctn);
    var mh = parseFloat(ta.css('min-height'));
    var lh = parseFloat(ta.css('line-height'));

    if (ta.height() - (lh * 3) <= mh) {
        t.prop('disabled', true);
    }

    ta.height(ta.height() - (lh * 3));
};

var SToolComponentSettingsPickerEdit = function () {
    var ctn = $(this).closest('.stool-component-settings-item-content');
    $('.stool-component-settings-icon-picker-content', ctn).slideToggle(300);
};

var SToolComponentSettingsPickerSave = function () {
    var ctn = $(this).closest('.stool-component-settings-item-content');
    var selectedItem = $('.stool-icopick-icon.selected', ctn);
    var message = $('.stool-component-settings-save-message', ctn);
    var key = $(this).attr('data-id');
    var currIcon = $('.stool-component-settings-icon-picker-icon', ctn);

    if (selectedItem.length !== 0) {
        var selectedValue = selectedItem.attr('data-name');
        var currSvg = selectedItem.html();
        var langs = $('html').attr('data-all-langs') || $('html').attr('data-all-lang');

        currIcon.html(currSvg);

        updateLabelLangs(key, selectedValue, langs, function () {
            message.addClass('show');

            setTimeout(function () {
                message.removeClass('show');
            }, 2000);
        }, true);
    }
};

var SToolComponentSettingsDelOpen = function () {
    var popupId = $(this).closest('.stool-component-settings-popup').attr('data-id');
    var componentId = $('.stool-component-settings-btn[data-id="' + popupId + '"]').closest('.componentContainerDiv').attr('id');
    var ctn = $(this).closest('.stool-component-settings-component-controls').find('.stool-component-settings-component-controls-del-ctn');

    ctn.find('input[name="componentId"]').val(componentId.substring(componentId.indexOf('_') + 1));
    ctn.slideDown(200);
};

var SToolComponentSettingsDelClose = function () {
    $(this).closest('.stool-component-settings-component-controls')
            .find('.stool-component-settings-component-controls-del-ctn')
            .slideUp(200);
};

$(document).ready(function () {
    function removeScrollBar(parent, child) {
        child.style.paddingRight = child.offsetWidth - child.clientWidth + "px";
    }
    $('.picker-popup-button').click(pickerOpenPopup);       
    $('body').on('click', '.file-preview-picker-tab-btn', pickerChangeTab);
    $('body').on('click', '.file-preview-picker-popup-selection-del', pickerSelectionItemDel);
    initPickerSelectionItemsSortable();
    initFilePickerPopop($('.file-preview-picker-popup-accept-btn'));

    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-item-header-toggle', genListToggleItem);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-add-item-btn', genListAddItem);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-item-del-btn', genListDelete);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-item-checkbox-input', genListCheckboxInputClick);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('change', '.gen-com-select .gen-list-popup-item-select', genListItemGenComChange);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-submit-btn', genListSubmit);
    initGenListPopupItemsLimit();
    initGenListPopupItemsSortable();
    $('.gen-list-popup:not(.gen-list-child-popup)').on('change', '.gen-list-popup-admin-item-type', genListPopupAdminUpdateExtra);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-admin-add-btn', genListPopupAdminAddItem);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-admin-save-btn', genListPopupAdminAddSaveList);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-admin-item-del-btn', genListPopupAdminDelItem);
    initGenListPopupAdminSortable();
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-admin-item-extra-select-add', genListSaveAdminSelectAdd);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('change', '.gen-list-popup-admin-item-extra-select-select', genListSelectAdminSelectType);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('click', '.gen-list-popup-admin-item-extra-select-del', genListSaveAdminSelectDelItem);
    initGenListPopupAdminSelectSortable();
    $('.gen-list-popup:not(.gen-list-child-popup)').on('change', '.gen-list-popup-admin-item-extra-icon-select', genListPopupAdminIconSelectChange);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('change', '.gen-list-popup-item-select-country', genListSelectCountryChange);
    $('.gen-list-popup:not(.gen-list-child-popup)').on('blur', '.gen-list-popup-admin-item-header-title', genListUpdateTitle);

    $('body').on('click', '.file-preview-picker-item:not(.folder)', filePreviewPickerItemClick);
    //$('.file-preview-picker-popup').on('click', '.file-preview-picker-item.folder', filePreviewPickerDirectoryOpen);
    $('.file-preview-picker-popup-btn-ctn').on('click', '.file-preview-picker-popup-accept-btn', filePreviewPickerSumbit);
    $('.file-preview-picker-input').keyup(filePreviewPickerSearch);
    $('.gen-list-search-input').keyup(genListSearch);

    CPclearCanvasListeners();
    CPsetupHueCanvas();
    CPsetupCanvasListeners();
    CPsetColor();

    genListFilterMultipleSelectOptions();
    $('.gen-list-popup-item-select').each(function () {
        if ($(this).closest('.gen-list-popup-item-select-ctn').attr('data-multi') === 'true') {
            $(this).on('change', genListPopupItemSelectChange);
            $('.gen-list-popup-item-select-selected-item-del').click(genListPopupItemSelectDel);
        }
    });

    genlistTinyMCE('.gen-list-mce:not([id^="mce_"])');

    //A small workaround to detect if the tool has a custom function with callback to close the popup
    //Else, it will do a normal pickerClosePopup()
    $('.picker-popup-close-btn').each(function () {
        var t = $(this);

        if (t.closest('.file-preview-picker-popup').length !== 0) {
            t.click(filePreviewPickerClosePopup);
        } else {
            t.click(pickerClosePopup);
        }
    });

    $('.file-preview-picker-item.folder').click(filePreviewPickerDirectoryOpen);
    $('.file-preview-picker-directory-back').click(filePreviewPickerDirectoryClose);
    
    /* File preview picker drag and drop */
    $('.file-preview-picker-popup-upload-dadzone').on('dragover', function(e) {
        this.style.backgroundColor = "#DDD";
        e.preventDefault();
    });
    $('.file-preview-picker-popup-upload-dadzone').on('dragleave', function(e) {
        this.style.backgroundColor = "";
        e.preventDefault();
    });
    $('.file-preview-picker-popup-upload-dadzone').on('drop', filePreviewPickerHandleDrop);
    $('.file-preview-picker-popup-upload-dadzone').on('click', function() {
        $(this).closest('.file-preview-picker-popup-upload').find('.file-preview-picker-popup-upload-form .bulk').trigger('click');
    });
    $('.file-preview-picker-popup-upload-form .bulk').on("change", filePreviewPickerHandleDrop);

    $('.social-popup-submit-btn').click(socialPopupSubmitClick);
    initSocialSortable();

    $('.anchor-setter-open-btn').add($('.anchor-setter-cancel-btn')).click(function () {
        var t = $(this);
        var ctn = t.closest('.anchor-setter');

        if (ctn.hasClass('open')) {
            ctn.removeClass('open');
        } else {
            ctn.addClass('open');
        }
    });

    $('.anchor-setter-save-btn').click(function () {
        var t = $(this);
        var ctn = t.closest('.anchor-setter');
        var val = $('input[name="anchor"]').val();
        var id = ctn.attr('data-id');
        var lang = ctn.attr('data-lang');

        updateLabelLangs(id, val, lang);
        ctn.attr('data-saved-value', val);
    });

    $('.anchor-setter-copy-btn').click(function () {
        var t = $(this);
        var ctn = t.closest('.anchor-setter');
        var val = ctn.attr('data-saved-value');

        window.prompt('Press Ctrl + C, then Enter to copy to clipboard', window.location.href + '#' + val);
    });

    $('.graph-tool-canvas').each(function () {
        initChartCanvas($(this).attr('id'));
    });

    $(".choose-custom-links").on("click", openCustomLinks);
    $(".admin-page-name").on("click", selectCustomLink);
    $(".add-custom-link").on("click", addCustomLink);
    $(".admin-custom-link-delete").on("click", delCustomLink);
    $(".save-custom-links").on("click", saveCustomLinks);

    if ($('.stool-shared-popup').length > 0) {
        var popupBtns = $('.stool-shared-popup-btn');
        popups = $('.stool-shared-popup-outer');

        $('body').on('click', '.stool-shared-popup-btn', openPopup);
        $('body').on('click', '.stool-shared-popup-close-btn', closePopup);
        popups.on('click', closePopup);
        popups.on('mousedown', sharedPopupMouseDown);
    }

    $('.stool-component-settings-link-save').click(SToolComponentSettingsLinkSave);

    $('.stool-component-settings-btn.stool-shared-popup-btn').click(darkenOtherComponents);
    $('.stool-component-settings-popup .stool-shared-popup-close-btn').click(removeDarkenComponents);

    $('.stool-shared-tab').click(changeTab);

    if ($('.stool-shared-tab')[0]) {
        window.addEventListener("popstate", function (e) {
            updateTab(e);
        });
    }

    $('body').on('change', '.stool-component-settings-checkbox-input.update-label', compSettingsCheckboxUpdateLabel); //need init on body for new PMI Mtl
    $('.stool-component-settings-checkbox-ctn').on('focus', '.stool-component-settings-input', compSettingsFocusCheck);
    $('.stool-component-settings-select.update-label').change(compSettingsSelectUpdateLabel);
    $('.stool-component-settings-input.update-label').change(compSettingsSelectUpdateLabel);
    $('.stool-component-settings-item-label-save').click(compSettingsEditableLabelUpdate);
    $('.stool-component-settings-item-mce-save').click(compSettingsEditableMCEUpdate);
    $('.stool-component-settings-item-label-input-more').click(compSettingsEditableLabelMoreHeight);
    $('.stool-component-settings-item-label-input-less').click(compSettingsEditableLabelLessHeight);
    $('.stool-component-settings-icon-picker-edit-btn').click(SToolComponentSettingsPickerEdit);
    $('.stool-component-settings-icon-picker-save-btn').click(SToolComponentSettingsPickerSave);
    $('.stool-component-settings-component-controls-del-btn').click(SToolComponentSettingsDelOpen);
    $('.stool-component-settings-component-controls-del-cancel-btn').click(SToolComponentSettingsDelClose);

    initCustomLinksDraggable();  
});

function initTools(imagepicker){
    $('div > .picker-popup-button',$(imagepicker)).off().click(pickerOpenPopup);       
    if ($(imagepicker).find('.file-preview-picker-popup-selection-list').length !== 0) {
        $(imagepicker).find('.file-preview-picker-popup-selection-list').sortable({
            handle: ".file-preview-picker-popup-selection-handle",
            helper: fixHelper
        });
    }
    initFilePickerPopop($('div > .file-preview-picker-popup-accept-btn',$(imagepicker)));
    $('div > .file-preview-picker-popup-btn-ctn',$(imagepicker)).off().on('click', '.file-preview-picker-popup-accept-btn', filePreviewPickerSumbit);
    $('div > .file-preview-picker-input',$(imagepicker)).off().keyup(filePreviewPickerSearch);
    
    //A small workaround to detect if the tool has a custom function with callback to close the popup
    //Else, it will do a normal pickerClosePopup()
    $('div > .picker-popup-close-btn',$(imagepicker)).each(function () {
        var t = $(this);

        if (t.closest('.file-preview-picker-popup').length !== 0) {
            t.click(filePreviewPickerClosePopup);
        } else {
            t.click(pickerClosePopup);
        }
    });

    $('div > .file-preview-picker-item.folder',$(imagepicker)).off().click(filePreviewPickerDirectoryOpen);
    $('div > .file-preview-picker-directory-back',$(imagepicker)).off().click(filePreviewPickerDirectoryClose);
}
function cropImageEdit(id, async) {
    async = async == undefined ? false : async;
    var editor = document.getElementById(id);

    var MIME_IMAGE = {
        ".gif": "image/gif",
        ".jpeg": "image/jpeg",
        ".jpg": "image/jpeg",
        ".png": "image/png"
    };

    if (editor !== null) {
        var ctrler = editor.querySelector(".imed-ctrl"),
                sizer = editor.querySelector(".imed-res"),
                img1 = editor.querySelector(".iei1"),
                img2 = editor.querySelector(".iei2"),
                scaler = editor.querySelector(".imed-sca"),
                moving = false,
                uploadName = editor.querySelector(".file-upload-title"),
                uploadFile = editor.querySelector(".file-upload-input"),
                inputEditing = editor.querySelector(".imed-ie"),
                inputDeleting = null;

        var oe = {
            mouseX: 0,
            mouseY: 0,
            imgX: 0,
            imgY: 0,
            baseW: 8,
            baseH: 8,
            cropW: sizer.clientWidth,
            cropH: sizer.clientHeight,
            ratio: sizer.clientWidth / sizer.clientHeight,
            scaleratio: 1,
            scaleby: "width",
            limit: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                minWidth: 8,
                maxWidth: 4000,
                minHeight: 8,
                maxHeight: 4000,
                minScale: 5,
                maxScale: 180
            },
            mediaId: editor.querySelector(".imed-mi").value,
            curSrc: editor.querySelector(".imed-cur").src,
            defSrc: img1.src
        };

        function checkFile(e, el) {
            var file = el.files[0],
                    ext = file.name.substr(file.name.lastIndexOf(".")).toLowerCase(),
                    lang = document.documentElement.lang;

            if (!(ext in MIME_IMAGE)) {
                uploadName.value = lang === "fr" ? "Fichier invalid" : "Invalid file";
                return false;
            }
            if (file.size < 160 || file.size > 10485760) {
                uploadName.value = lang === "fr" ? "Fichier est trop large ou trop petit"
                        : "File is too large or too small";
                return false;
            }
            return true;
        }
        /*function loadFile(e) {
         if (!checkFile(e, this)) {
         this.value = "";
         $(uploadName).addClass("error");
         return false;
         } else {
         $(uploadName).removeClass("error");
         }
         
         var newImg1 = document.createElement("IMG"),
         newImg2 = document.createElement("IMG");
         
         newImg1.src = newImg2.src = window.URL.createObjectURL(e.target.files[0]);
         newImg1.className = img1.className;
         newImg2.className = img2.className;
         newImg1.onload = function() {
         editor.querySelector(".imed-pho").replaceChild(newImg1, img1);
         sizer.replaceChild(newImg2, img2);
         img1 = newImg1;
         img2 = newImg2;
         toggleMedia(true);
         start();
         };
         }*/

        function start() {
            if (img1.width > 0 && img2.width > 0 && oe.cropH > 0 && oe.ratio) {
                checkCropArea();
                initImage();
                setScaleLimit();
            }
            //console.log(oe);
        }
        function checkCropArea() {
            var zoneW = editor.querySelector(".imed-zo1-inner").clientWidth;
            //oe.cropW = sizer.clientWidth;
            if (oe.cropW > zoneW) {
                var area = editor.querySelector(".imed-pho");
                area.style.width = zoneW + "px";
                area.style.height = Math.round(zoneW / oe.ratio) + "px";
                oe.scaleratio = zoneW / oe.cropW;
                oe.cropW = zoneW;
                oe.cropH = area.clientHeight;
                scaler.setAttribute("data-min-width", oe.cropW);
                scaler.setAttribute("data-min-height", oe.cropH);
            }
        }
        function initImage() {
            oe.baseW = Math.round(img1.naturalWidth * oe.scaleratio);
            oe.baseH = Math.round(img1.naturalHeight * oe.scaleratio);
            if (oe.baseW / oe.baseH > oe.ratio) {
                oe.scaleby = "height";
                istyle("height", Math.max(oe.baseH, oe.cropH) + "px");
                istyle("width", "");
            } else {
                oe.scaleby = "width";
                istyle("width", Math.max(oe.baseW, oe.cropW) + "px");
                istyle("height", "");
            }
            setPositionLimit();
            imove((oe.cropW - img1.width) / 2, (oe.cropH - img1.height) / 2);
            setPosition();
        }

        function setPositionLimit() {
            oe.limit.right = oe.cropW - img1.width;
            oe.limit.bottom = oe.cropH - img1.height;
        }
        function setScaleLimit() {
            var data = $(scaler).data();
            if (!parseInt(data.maxWidth))
                data.maxWidth = 4000;
            if (!parseInt(data.maxHeight))
                data.maxHeight = 4000;

            data.minScale = Math.max(oe.cropW / oe.baseW, oe.cropH / oe.baseH, 0.05) * 100;
            data.minScale = data.minScale.toFixed(4);
            data.maxScale = Math.max(data.minScale, 100) + 80;
            scaler.setAttribute("max", data.maxScale);
            scaler.setAttribute("min", data.minScale);
            scaler.value = Math.max(data.minScale, 100);

            Object.assign(oe.limit, data);
        }
        function setPosition() {
            oe.imgX = img1.offsetLeft;
            oe.imgY = img1.offsetTop;
        }

        function mdown(e) {
            e.preventDefault();
            e.stopPropagation();
            moving = true;
            var orEv = e.originalEvent || e;
            oe.mouseX = e.pageX || e.clientX || orEv.touches[0].clientX;
            oe.mouseY = e.pageY || e.clientY || orEv.touches[0].clientY;
        }
        function mmove(e) {
            e.preventDefault();
            if (moving) {
                var orEv = e.originalEvent || e;
                var x = e.pageX || e.clientX || orEv.touches[0].clientX;
                var y = e.pageY || e.clientY || orEv.touches[0].clientY;
                imove(oe.imgX + x - oe.mouseX, oe.imgY + y - oe.mouseY);
            }
        }
        function mup(e) {
            e.preventDefault();
            moving = false;
            setPosition();
            iput();
        }

        function imove(x, y) {
            if (img1.width >= oe.cropW) {
                istyle("left", within(x, oe.limit.right, oe.limit.left) + "px");
            } else {
                istyle("left", within(x, oe.limit.left, oe.limit.right) + "px");
            }
            if (img1.height >= oe.cropH) {
                istyle("top", within(y, oe.limit.bottom, oe.limit.top) + "px");
            } else {
                istyle("top", within(y, oe.limit.top, oe.limit.bottom) + "px");
            }
        }
        function iresize(e) {
            var w = img1.width,
                    h = img1.height,
                    nw = within(Math.round(oe.baseW * (scaler.value / 100)), oe.limit.minWidth, oe.limit.maxWidth),
                    nh = within(Math.round(oe.baseH * (scaler.value / 100)), oe.limit.minHeight, oe.limit.maxHeight);

            if (oe.scaleby === "width") {
                istyle("width", nw + "px");
                istyle("height", "");
            } else {
                istyle("width", "");
                istyle("height", nh + "px");
            }
            setPositionLimit();
            imove(oe.imgX - (nw - w) / 2, oe.imgY - (nh - h) / 2);
            setPosition();
        }
        function istyle(prop, val) {
            img1.style[prop] = img2.style[prop] = val;
        }
        function within(value, min, max) {
            return value < min ? min : value > max ? max : value;
        }
        function iput() {
            editor.querySelector(".imed-ox").value = Math.round(-oe.imgX / oe.scaleratio);
            editor.querySelector(".imed-oy").value = Math.round(-oe.imgY / oe.scaleratio);
            editor.querySelector(".imed-sr").value = scaler.value / 100;
        }

        function toggleMedia(active) {
            if (active) {
                $(editor).removeClass("nosrc").removeClass("hascrop");
                inputEditing.value = "true";
            } else {
                $(editor).addClass("nosrc");
                inputEditing.value = "";
                $(uploadFile).val("").change();
                $(uploadName).val("").removeClass("error");
                if (oe.mediaId !== "" && parseInt(oe.mediaId) > 0 && oe.curSrc.length > 1) {
                    $(editor).addClass("hascrop");
                    $(uploadName).parent().removeClass("error");
                }
            }
        }
        function toggleDelete(active) {
            if (active) {
                inputDeleting = document.createElement("INPUT");
                inputDeleting.type = "hidden";
                inputDeleting.name = "delProfilePic";
                inputDeleting.value = "true";
                editor.appendChild(inputDeleting);
                $(editor).addClass("removal");
            } else {
                if (inputDeleting) {
                    editor.removeChild(inputDeleting);
                    inputDeleting = null;
                }
                $(editor).removeClass("removal");
            }
        }
        function edit(e) {
            img1.src = img2.src = oe.defSrc;
            setTimeout(function () {
                toggleDelete(false);
                toggleMedia(true);
                start();
            }, 100);
        }
        // In case the container is not displayed, try to reinitiate until the
        // crop's dimension is calculated.
        function checkSizer() {
            if (sizer.clientHeight > 0 && oe.cropH <= 0 && !oe.ratio) {
                oe.cropW = sizer.clientWidth;
                oe.cropH = sizer.clientHeight;
                oe.ratio = sizer.clientWidth / sizer.clientHeight;
                start();
            } else {
                setTimeout(checkSizer, 1000);
            }
        }

        /* Initiate */
        if (!async) {
            start();
        } else {
            $(img1).on('load', start);
        }


        $(window).on('load', function () {
            checkSizer();
            iresize();
        });

        $(window).resize(checkCropArea);

        ctrler.addEventListener("mousedown", mdown);
        ctrler.addEventListener("mousemove", mmove);
        ctrler.addEventListener("mouseup", mup);
        ctrler.addEventListener("mouseout", mup);
        ctrler.addEventListener("touchstart", mdown);
        ctrler.addEventListener("touchmove", mmove);
        ctrler.addEventListener("touchend", mup);
        ctrler.addEventListener("touchcancel", mup);
        scaler.addEventListener("input", iresize);
        scaler.addEventListener("change", mup);

        //uploadFile.addEventListener("change", loadFile);

        editor.querySelector(".imed-mod").addEventListener("click", edit);
    }
}

function formatStringForUrlHandle(string) {
    string = string.trim();
    string = string.toLowerCase();
    string = string.replace(new RegExp("['`^¸:;.,¨!/$%?&*(){}\"]", "g"), "");
    string = string.replace(new RegExp(" ", "g"), "-");
    string = string.replace(new RegExp("(\\-)\\1+", "g"), "-");
    string = string.replace(new RegExp("[àâä]", "g"), "a");
    string = string.replace(new RegExp("[èêéë]", "g"), "e");
    string = string.replace(new RegExp("ç", "g"), "c");
    string = string.replace(new RegExp("[îï]", "g"), "i");
    string = string.replace(new RegExp("[òô]", "g"), "o");
    string = string.replace(new RegExp("û", "g"), "u");
    string = string.replace(new RegExp("œ", "g"), "oe");
    string = string.replace(new RegExp("æ", "g"), "ae");

    string = encodeURIComponent(string);

    return string;
}

function textLabelWindow(id, ctn, key, absoluteURLs) {
    var content = ctn.innerHTML;
    if (content === ctn.getAttribute("data-ignore")) {
        content = "";
    }
    document.getElementById(id + "_key").value = key;
    document.getElementById(id + "_value").value = content;
    if (absoluteURLs) {
        $("#" + id).find("." + id + "-save").attr("data-absolute", true);
    } else {
        $("#" + id).find("." + id + "-save").removeAttr("data-absolute");
    }
    tinymce.get(id + "_value").load();

    var prevCtn = document.getElementById(id + "_src");
    if (prevCtn)
        prevCtn.id = "";
    ctn.id = id + "_src";


    openWindow(id);
}

function noFunc(url, node, on_save, name) {

}

function submitTextLabel(id) {
    var content = tinymce.get(id + "_value").getContent();
    if ($("#" + id).find("." + id + "-save").attr("data-absolute") !== undefined && $("#" + id).find("." + id + "-save").attr("data-absolute") === 'true') {
        var domain = $("#" + id).find("." + id + "-save").attr("data-domain") + "/";
        content = tinymce.get(id + "_value").getContent()
                .replace(/ src="\//g, " src=\"" + domain)
                .replace(/ href="(?!(https?|mailto|tel)\:)/gm, " href=\"" + domain);
    }

    updateLabel(document.getElementById(id + "_key").value, content, document.documentElement.lang, function (resp) {
        var ctn = document.getElementById(id + "_src");
        ctn.innerHTML = decodeURIComponent(resp.trim().replace(/\+/g, " "));
    });

    closeWindow(id);
}
function submitTextLabel2(id) {
    updateLabel(document.getElementById(id + "_key").value, tinymce.get(id + "_value").getContent(), document.documentElement.lang, function (resp) {
        var ctn = document.getElementById(id + "_src");
        ctn.innerHTML = decodeURIComponent(resp.trim().replace(/\+/g, " "));
    });

    closeWindow(id);
}
function eraseTextLabel(id) {
    updateLabel(document.getElementById(id + "_key").value, "", document.documentElement.lang, function (resp) {
        var ctn = document.getElementById(id + "_src");
        ctn.innerHTML = decodeURIComponent(resp.trim().replace(/\+/g, " "));
    });

    closeWindow(id);
}

function l10n(fr, en, es) {
    var ln = lang || document.documentElement.lang;
    return ln === "fr" ? fr : ln === "es" ? es : en;
}

var isoCountries = {
    'AF': 'Afghanistan',
    'AX': 'Aland Islands',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctica',
    'AG': 'Antigua And Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermuda',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia And Herzegovina',
    'BW': 'Botswana',
    'BV': 'Bouvet Island',
    'BR': 'Brazil',
    'IO': 'British Indian Ocean Territory',
    'BN': 'Brunei Darussalam',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CV': 'Cape Verde',
    'KY': 'Cayman Islands',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CX': 'Christmas Island',
    'CC': 'Cocos (Keeling) Islands',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Congo, Democratic Republic',
    'CK': 'Cook Islands',
    'CR': 'Costa Rica',
    'CI': 'Cote D\'Ivoire',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czech Republic',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FK': 'Falkland Islands (Malvinas)',
    'FO': 'Faroe Islands',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'France',
    'GF': 'French Guiana',
    'PF': 'French Polynesia',
    'TF': 'French Southern Territories',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Germany',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GR': 'Greece',
    'GL': 'Greenland',
    'GD': 'Grenada',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GG': 'Guernsey',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HM': 'Heard Island & Mcdonald Islands',
    'VA': 'Holy See (Vatican City State)',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran, Islamic Republic Of',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IM': 'Isle Of Man',
    'IL': 'Israel',
    'IT': 'Italy',
    'JM': 'Jamaica',
    'JP': 'Japan',
    'JE': 'Jersey',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KR': 'Korea',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Lao People\'s Democratic Republic',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libyan Arab Jamahiriya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MK': 'Macedonia',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MQ': 'Martinique',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'YT': 'Mayotte',
    'MX': 'Mexico',
    'FM': 'Micronesia, Federated States Of',
    'MD': 'Moldova',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MS': 'Montserrat',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'AN': 'Netherlands Antilles',
    'NC': 'New Caledonia',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'NU': 'Niue',
    'NF': 'Norfolk Island',
    'MP': 'Northern Mariana Islands',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestinian Territory, Occupied',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PN': 'Pitcairn',
    'PL': 'Poland',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'QA': 'Qatar',
    'RE': 'Reunion',
    'RO': 'Romania',
    'RU': 'Russian Federation',
    'RW': 'Rwanda',
    'BL': 'Saint Barthelemy',
    'SH': 'Saint Helena',
    'KN': 'Saint Kitts And Nevis',
    'LC': 'Saint Lucia',
    'MF': 'Saint Martin',
    'PM': 'Saint Pierre And Miquelon',
    'VC': 'Saint Vincent And Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome And Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'South Africa',
    'GS': 'South Georgia And Sandwich Isl.',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SJ': 'Svalbard And Jan Mayen',
    'SZ': 'Swaziland',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syrian Arab Republic',
    'TW': 'Taiwan',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad And Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TC': 'Turks And Caicos Islands',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'US': 'United States',
    'UM': 'United States Outlying Islands',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VE': 'Venezuela',
    'VN': 'Viet Nam',
    'VG': 'Virgin Islands, British',
    'VI': 'Virgin Islands, U.S.',
    'WF': 'Wallis And Futuna',
    'EH': 'Western Sahara',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe'
};

function getCountryName(countryCode) {
    if (isoCountries.hasOwnProperty(countryCode)) {
        return isoCountries[countryCode];
    } else {
        return countryCode;
    }
}